<template>
  <div id="section-to-print">
    <!-- /////////////////////////////////DIREKSI//////////////////////////////////////////// -->
    <div class="row add-page-break-after">
      <div class="col-12">
        <div class="p-3 mb-3">
          <div class="row">
            <div class="col-12">
              <h5 style="font-weight: bold">
                PERUSAHAAN UMUM DAERAH AIR MINUM
              </h5>
              <h5 style="font-weight: bold">TIRTA HITA BULELENG</h5>
              <h4 class="header-title">
                <strong>DAFTAR PEMBAYARAN GAJI DAN TUNJANGAN DIREKSI </strong>
              </h4>
              <h5 class="header-periode" style="padding-bottom: 20px">
                <strong
                  >UNTUK BULAN: {{ printBulanNama() }}
                  {{ printTahun() }}</strong
                >
              </h5>

              <table
                class="table table-sm table-custom no-margin-br"
                v-if="gajisDireksi"
              >
                <thead>
                  <tr class="center-top-text">
                    <th rowspan="3">NO</th>
                    <th rowspan="3" class="col-pegawai">
                      NAMA<br />
                      <br />NIP/NIK<br />JABATAN
                    </th>
                    <th rowspan="3" colspan="2">GOL.</th>
                    <th rowspan="2">GAJI POKOK</th>
                    <th colspan="7" rowspan="1">TUNJANGAN</th>
                    <th colspan="2" rowspan="1">POT. KETIDAKHADIRAN</th>
                    <th rowspan="2">JUMLAH BRUTO</th>
                    <th rowspan="2">TUNJANGAN PPH</th>
                    <th rowspan="2">JUMLAH (14+15)</th>
                    <th rowspan="1" colspan="5">POTONGAN</th>
                    <th rowspan="3">JUMLAH YANG DITERIMA</th>
                    <th rowspan="3" colspan="2">TANDA TANGAN</th>
                  </tr>

                  <tr class="center-top-text">
                    <th>
                      PERUSAHAAN
                      <div class="small-text">(5)x 25%</div>
                    </th>
                    <th>JABATAN</th>
                    <th>
                      KEMAHALAN
                      <div class="small-text">(5)x 5%</div>
                    </th>
                    <th>AIR</th>
                    <th>TRANSPORT</th>
                    <th>PANGAN</th>
                    <th>KESEHATAN</th>
                    <th>HARI</th>
                    <th>
                      JUMLAH
                      <div class="small-text">13X5%(6+10)</div>
                    </th>
                    <th>KESEHATAN</th>
                    <th>
                      BPJS TK 3 PROGRAM
                      <div class="small-text">(15)X2%</div>
                    </th>
                    <th>
                      BPJS TK 4 PROGRAM
                      <div class="small-text">(Bts maxX1% JP)+ 2% JHT</div>
                    </th>
                    <th>PENSIUN JIWASRAYA</th>
                    <th>PPH</th>
                  </tr>

                  <tr class="center-top-text">
                    <th style="border: none">(Rp.)</th>
                    <th>(Rp.)</th>
                    <th>(Rp.)</th>
                    <th>(Rp.)</th>
                    <th>(Rp.)</th>
                    <th>(Rp.)</th>
                    <th>(Rp.)</th>
                    <th>(Rp.)</th>
                    <th>(Rp.)</th>
                    <th>(Rp.)</th>
                    <th>(Rp.)</th>
                    <th>(Rp.)</th>
                    <th>(Rp.)</th>
                    <th>(Rp.)</th>
                    <th>(Rp.)</th>
                    <th>(Rp.)</th>
                    <th>(Rp.)</th>
                    <th>(Rp.)</th>
                  </tr>
                  <tr class="center-top-text">
                    <th>1</th>
                    <th>2</th>
                    <th>3</th>
                    <th>4</th>
                    <th>5</th>
                    <th>6</th>
                    <th>7</th>
                    <th>8</th>
                    <th>9</th>
                    <th>10</th>
                    <th>11</th>
                    <th>12</th>
                    <th>13</th>
                    <th>14</th>
                    <th>15</th>
                    <th>16</th>
                    <th>17</th>
                    <th>18</th>
                    <th>19</th>
                    <th>20</th>
                    <th>20</th>
                    <th>21</th>
                    <th>22</th>
                    <th></th>
                    <th>24</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- TODO -->
                  <tr
                    v-for="(item, index) in gajisDireksi.gajis"
                    :key="item.id"
                    :class="getPageBreakStyle(index)"
                  >
                    <!-- :class="'top-text table-row-vfor'"
                            :style="getPageBreakStyle(index)" -->
                    <td style="border: 1px solid #000">
                      {{ index + 1 }}
                    </td>
                    <td style="border: 1px solid #000">
                      {{ item.pegawai.nama }}
                      <br />NIK.
                      {{ item.pegawai.nik }}
                    </td>
                    <td style="border: 1px solid #000">
                      <!-- style="white-space: pre-line" -->
                      {{ item.golongan.nama }}
                    </td>

                    <td style="border: 1px solid #000">
                      {{ item.pegawai.status_ptkp }}
                    </td>

                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.gaji_pokok) }}
                    </td>

                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.tun_perusahaan) }}
                    </td>

                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.tun_jabatan) }}
                    </td>

                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.tun_kemahalan) }}
                    </td>

                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.tun_air) }}
                    </td>

                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.tun_transport) }}
                    </td>

                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.tun_pangan) }}
                    </td>

                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.tun_kesehatan) }}
                    </td>

                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.jml_tdk_hadir) }}
                    </td>

                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.pot_5_persen) }}
                    </td>

                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.jml_bruto) }}
                    </td>

                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.tun_pph) }}
                    </td>
                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.pot_5_persen + item.jml_bruto) }}
                    </td>
                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.pot_kesehatan) }}
                    </td>
                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.pot_bpjs_tk_tiga_program) }}
                    </td>
                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.pot_bpjs_tk_empat_program) }}
                    </td>
                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.pot_pensiun) }}
                    </td>
                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.pot_pph) }}
                    </td>
                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.total_diterima) }}
                    </td>
                    <td style="border: 1px solid #000" class="bottom-text">
                      {{ index + 1 }}
                    </td>
                    <td class="bottom-text">...............</td>
                  </tr>
                </tbody>
                <!-- <tfoot> -->
                <tr
                  class="top-text table-row-vfor"
                  v-if="gajisDireksi.totalGajis"
                >
                  <td style="border: 1px solid #000"></td>
                  <td style="border: 1px solid #000; font-weight: bold">
                    JUMLAH
                  </td>
                  <td style="border: 1px solid #000"></td>
                  <td style="border: 1px solid #000"></td>

                  <td style="border: 1px solid #000">
                    {{ formatNumber(gajisDireksi.totalGajis.gaji_pokok) }}
                  </td>

                  <td style="border: 1px solid #000">
                    {{ formatNumber(gajisDireksi.totalGajis.tun_perusahaan) }}
                  </td>

                  <td style="border: 1px solid #000">
                    {{ formatNumber(gajisDireksi.totalGajis.tun_jabatan) }}
                  </td>

                  <td style="border: 1px solid #000">
                    {{ formatNumber(gajisDireksi.totalGajis.tun_kemahalan) }}
                  </td>

                  <td style="border: 1px solid #000">
                    {{ formatNumber(gajisDireksi.totalGajis.tun_air) }}
                  </td>

                  <td style="border: 1px solid #000">
                    {{ formatNumber(gajisDireksi.totalGajis.tun_transport) }}
                  </td>

                  <td style="border: 1px solid #000">
                    {{ formatNumber(gajisDireksi.totalGajis.tun_pangan) }}
                  </td>

                  <td style="border: 1px solid #000">
                    {{ formatNumber(gajisDireksi.totalGajis.tun_kesehatan) }}
                  </td>

                  <td style="border: 1px solid #000">
                    {{ formatNumber(gajisDireksi.totalGajis.jml_tdk_hadir) }}
                  </td>

                  <td style="border: 1px solid #000">
                    {{ formatNumber(gajisDireksi.totalGajis.pot_5_persen) }}
                  </td>

                  <td style="border: 1px solid #000">
                    {{ formatNumber(gajisDireksi.totalGajis.jml_bruto) }}
                  </td>

                  <td style="border: 1px solid #000">
                    {{ formatNumber(gajisDireksi.totalGajis.tun_pph) }}
                  </td>
                  <td style="border: 1px solid #000">
                    {{
                      formatNumber(
                        gajisDireksi.totalGajis.tun_pph +
                          gajisDireksi.totalGajis.jml_bruto
                      )
                    }}
                  </td>
                  <td style="border: 1px solid #000">
                    {{ formatNumber(gajisDireksi.totalGajis.pot_kesehatan) }}
                  </td>
                  <td style="border: 1px solid #000">
                    {{
                      formatNumber(
                        gajisDireksi.totalGajis.pot_bpjs_tk_tiga_program
                      )
                    }}
                  </td>
                  <td style="border: 1px solid #000">
                    {{
                      formatNumber(
                        gajisDireksi.totalGajis.pot_bpjs_tk_empat_program
                      )
                    }}
                  </td>
                  <td style="border: 1px solid #000">
                    {{ formatNumber(gajisDireksi.totalGajis.pot_pensiun) }}
                  </td>
                  <td style="border: 1px solid #000">
                    {{ formatNumber(gajisDireksi.totalGajis.pot_pph) }}
                  </td>
                  <td style="border: 1px solid #000">
                    {{ formatNumber(gajisDireksi.totalGajis.total_diterima) }}
                  </td>
                  <td style="border: 1px solid #000" class="bottom-text"></td>
                  <td class="bottom-text"></td>
                </tr>
                <tr></tr>
                <!-- <tr>
                          <td colspan="24" class="no-border-terbilang">
                            Terbilang : -----
                            {{
                              formatNumberTerbilang(
                                gajis.totalGajis.pot_5_persen +
                                  gajis.totalGajis.jml_bruto
                              )
                            }}
                            Rupiah -----
                          </td>
                        </tr> -->
                <!-- <tr>
                          <td colspan="24" class="no-border-terbilang">
                            <div class="row">
                              <div class="col-6">
                                Terbilang : -----
                                {{
                                  formatNumberTerbilang(
                                    gajis.totalGajis.pot_5_persen +
                                      gajis.totalGajis.jml_bruto
                                  )
                                }}
                                Rupiah -----
                                <br />
                                Perumda Air Minum <br />
                                Tirta Hita Buleleng <br />
                                Menyetujui: <br />
                                <br />
                                <br />
                                <div
                                  style="
                                    text-decoration: underline;
                                    padding-top: 35px;
                                  "
                                  v-if="pejabatMengetahui"
                                >
                                  {{ pejabatMengetahui.nama }}
                                </div>
  
                                Direktur Umum
                              </div> -->
                <!-- <div class="col-6">
                                <br />
                                <br />
                                <div v-if="gajis">
                                  Singaraja,
                                  {{ convertTgl(gajis.gajis[0].created_at) }}
                                </div>
  
                                Dibuat Oleh:<br />
                                <br />
                                <br />
                                <div
                                  style="
                                    text-decoration: underline;
                                    padding-top: 35px;
                                  "
                                  v-if="pejabatMembuat"
                                >
                                  {{ pejabatMembuat.nama }}
                                </div>
                                Ka. Sub Bag. Personalia
                              </div>
                            </div>
                          </td>
                        </tr> -->
              </table>
              <div class="row" v-if="gajisDireksi">
                <div class="col-12">
                  <p>
                    <!-- {{ formatNumber(gajis.totalGajis.pot_pph) }} -->
                    Terbilang : -----
                    {{
                      formatNumberTerbilang(
                        gajisDireksi.totalGajis.tun_pph +
                          gajisDireksi.totalGajis.jml_bruto
                      )
                    }}
                    Rupiah -----
                  </p>
                </div>
                <div class="row" style="text-align: center">
                  <div class="col-4">
                    Perumda Air Minum <br />
                    Tirta Hita Buleleng <br />
                    Menyetujui: <br />
                    <br />

                    <div
                      style="text-decoration: underline; padding-top: 35px"
                      v-if="pejabatMenyetujui"
                    >
                      {{ pejabatMenyetujui.nama }}
                    </div>

                    Direktur Umum
                  </div>
                  <div class="col-4">
                    <br />
                    <br />

                    Mengetahui:<br />
                    <br />

                    <div
                      style="text-decoration: underline; padding-top: 35px"
                      v-if="pejabatMengetahui"
                    >
                      {{ pejabatMengetahui.nama }}
                    </div>
                    Kepala Bagian Umum
                  </div>
                  <div class="col-4">
                    <br />
                    <div v-if="gajis">
                      Singaraja,
                      {{ convertTglIndonesia(gajis.gajis[0].created_at) }}
                    </div>

                    Dibuat Oleh:<br />
                    <br />

                    <div
                      style="text-decoration: underline; padding-top: 35px"
                      v-if="pejabatMembuat"
                    >
                      {{ pejabatMembuat.nama }}
                    </div>
                    Ka. Sub Bag. Personalia
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /col-12  -->
    </div>
    <!-- /////////////////////////////////TETAP//////////////////////////////////////////// -->

    <div v-for="cabang in cabangs" :key="cabang.id">
      hello im from cabang
      <!-- Render this div if cabang.id is equal to 1 -->
      <div v-if="cabang.id === 1">
        <!-- Content for cabang with id 1 -->
        <!-- iteration bagians -->
        <div v-for="bagian in bagians" :key="bagian.id">
          <div class="row add-page-break-after">
            <div class="col-12">
              <div class="p-3 mb-3">
                <div class="row">
                  <div class="col-12">
                    <h5 style="font-weight: bold">
                      PERUSAHAAN UMUM DAERAH AIR MINUM
                    </h5>
                    <h5 style="font-weight: bold">TIRTA HITA BULELENG</h5>
                    <h4 class="header-title">
                      <strong
                        >DAFTAR PEMBAYARAN GAJI DAN TUNJANGAN BAGIAN
                        {{ toUpper(bagian.nama) }}
                      </strong>
                    </h4>
                    <h5 class="header-periode" style="padding-bottom: 20px">
                      <strong
                        >UNTUK BULAN: {{ printBulanNama() }}
                        {{ printTahun() }}</strong
                      >
                    </h5>

                    <table
                      class="table table-sm table-custom no-margin-br"
                      v-if="gajis"
                    >
                      <thead>
                        <tr class="center-top-text">
                          <th rowspan="3">NO</th>
                          <th rowspan="3" class="col-pegawai">
                            NAMA<br />
                            <br />NIP/NIK<br />JABATAN
                          </th>
                          <th rowspan="3" colspan="2">GOL.</th>
                          <th rowspan="2">GAJI POKOK</th>
                          <th colspan="7" rowspan="1">TUNJANGAN</th>
                          <th colspan="2" rowspan="1">POT. KETIDAKHADIRAN</th>
                          <th rowspan="2">JUMLAH BRUTO</th>
                          <th rowspan="2">TUNJANGAN PPH</th>
                          <th rowspan="2">JUMLAH (14+15)</th>
                          <th rowspan="1" colspan="5">POTONGAN</th>
                          <th rowspan="3">JUMLAH YANG DITERIMA</th>
                          <th rowspan="3" colspan="2">TANDA TANGAN</th>
                        </tr>

                        <tr class="center-top-text">
                          <th>
                            PERUSAHAAN
                            <div class="small-text">(5)x 25%</div>
                          </th>
                          <th>JABATAN</th>
                          <th>
                            KEMAHALAN
                            <div class="small-text">(5)x 5%</div>
                          </th>
                          <th>AIR</th>
                          <th>TRANSPORT</th>
                          <th>PANGAN</th>
                          <th>KESEHATAN</th>
                          <th>HARI</th>
                          <th>
                            JUMLAH
                            <div class="small-text">13X5%(6+10)</div>
                          </th>
                          <th>KESEHATAN</th>
                          <th>
                            BPJS TK 3 PROGRAM
                            <div class="small-text">(15)X2%</div>
                          </th>
                          <th>
                            BPJS TK 4 PROGRAM
                            <div class="small-text">
                              (Bts maxX1% JP)+ 2% JHT
                            </div>
                          </th>
                          <th>PENSIUN JIWASRAYA</th>
                          <th>PPH</th>
                        </tr>

                        <tr class="center-top-text">
                          <th style="border: none">(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                        </tr>

                        <tr class="center-top-text">
                          <th>1</th>
                          <th>2</th>
                          <th>3</th>
                          <th>4</th>
                          <th>5</th>
                          <th>6</th>
                          <th>7</th>
                          <th>8</th>
                          <th>9</th>
                          <th>10</th>
                          <th>11</th>
                          <th>12</th>
                          <th>13</th>
                          <th>14</th>
                          <th>15</th>
                          <th>16</th>
                          <th>17</th>
                          <th>18</th>
                          <th>19</th>
                          <th>20</th>
                          <th>20</th>
                          <th>21</th>
                          <th>22</th>
                          <th></th>
                          <th>24</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in filterGajisByConditions(
                            [
                              {
                                indexs: ['riwayat_pekerjaan', 'cabang_id'],
                                val: cabang.id,
                              },
                              {
                                indexs: ['riwayat_pekerjaan', 'bagian_id'],
                                val: bagian.id,
                              },
                            ],
                            'sub_bagian_id',
                            'gajis'
                          )"
                          :key="item.id"
                          :class="getPageBreakStyle(index)"
                        >
                          <td style="border: 1px solid #000">
                            <span
                              :style="printNewLine(item.print_sub_bagian)"
                              v-if="subBagians"
                            >
                            </span>
                            {{ index + 1 }}
                          </td>
                          <td style="border: 1px solid #000">
                            <div
                              :style="boldStyle"
                              v-if="shouldRenderSubBagian"
                            >
                              {{
                                printSubBagian(
                                  item.print_sub_bagian,
                                  item.riwayat_pekerjaan
                                )
                              }}
                            </div>
                            {{ item.pegawai.nama }}
                            <br />NIK.
                            {{ item.pegawai.nik }}
                          </td>
                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ item.golongan.nama }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ item.pegawai.status_ptkp }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.gaji_pokok) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.tun_perusahaan) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.tun_jabatan) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.tun_kemahalan) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.tun_air) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.tun_transport) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.tun_pangan) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.tun_kesehatan) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.jml_tdk_hadir) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.pot_5_persen) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.jml_bruto) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.tun_pph) }}
                          </td>
                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.tun_pph + item.jml_bruto) }}
                          </td>
                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.pot_kesehatan) }}
                          </td>
                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.pot_bpjs_tk_tiga_program) }}
                          </td>
                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.pot_bpjs_tk_empat_program) }}
                          </td>
                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.pot_pensiun) }}
                          </td>
                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.pot_pph) }}
                          </td>
                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.total_diterima) }}
                          </td>
                          <td
                            style="border: 1px solid #000"
                            class="bottom-text"
                          >
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ index + 1 }}
                          </td>
                          <td class="bottom-text">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span
                            >...............
                          </td>
                        </tr>
                      </tbody>

                      <tr
                        class="top-text table-row-vfor"
                        v-if="gajis.totalGajis"
                      >
                        <td style="border: 1px solid #000"></td>
                        <td style="border: 1px solid #000; font-weight: bold">
                          JUMLAH
                        </td>
                        <td style="border: 1px solid #000"></td>
                        <td style="border: 1px solid #000"></td>

                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bagian_id"],
                                  val: bagian.id,
                                },
                              ],
                              "gajis",
                              "gaji_pokok"
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bagian_id"],
                                  val: bagian.id,
                                },
                              ],
                              "gajis",
                              "tun_perusahaan"
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bagian_id"],
                                  val: bagian.id,
                                },
                              ],
                              "gajis",
                              "tun_jabatan"
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bagian_id"],
                                  val: bagian.id,
                                },
                              ],
                              "gajis",
                              "tun_kemahalan"
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bagian_id"],
                                  val: bagian.id,
                                },
                              ],
                              "gajis",
                              "tun_air"
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bagian_id"],
                                  val: bagian.id,
                                },
                              ],
                              "gajis",
                              "tun_transport"
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bagian_id"],
                                  val: bagian.id,
                                },
                              ],
                              "gajis",
                              "tun_pangan"
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bagian_id"],
                                  val: bagian.id,
                                },
                              ],
                              "gajis",
                              "tun_kesehatan"
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bagian_id"],
                                  val: bagian.id,
                                },
                              ],
                              "gajis",
                              "jml_tdk_hadir"
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bagian_id"],
                                  val: bagian.id,
                                },
                              ],
                              "gajis",
                              "pot_5_persen"
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bagian_id"],
                                  val: bagian.id,
                                },
                              ],
                              "gajis",
                              "jml_bruto"
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bagian_id"],
                                  val: bagian.id,
                                },
                              ],
                              "gajis",
                              "tun_pph"
                            )
                          }}
                        </td>
                        <td style="border: 1px solid #000">
                          {{
                            getSumsColJml(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bagian_id"],
                                  val: bagian.id,
                                },
                              ],
                              "gajis"
                            )
                          }}

                          <!-- ini bentar otak error -->
                        </td>
                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bagian_id"],
                                  val: bagian.id,
                                },
                              ],
                              "gajis",
                              "pot_kesehatan"
                            )
                          }}
                        </td>
                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bagian_id"],
                                  val: bagian.id,
                                },
                              ],
                              "gajis",
                              "pot_bpjs_tk_tiga_program"
                            )
                          }}
                        </td>
                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bagian_id"],
                                  val: bagian.id,
                                },
                              ],
                              "gajis",
                              "pot_bpjs_tk_empat_program"
                            )
                          }}
                        </td>
                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bagian_id"],
                                  val: bagian.id,
                                },
                              ],
                              "gajis",
                              "pot_pensiun"
                            )
                          }}
                        </td>
                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bagian_id"],
                                  val: bagian.id,
                                },
                              ],
                              "gajis",
                              "pot_pph"
                            )
                          }}
                        </td>
                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bagian_id"],
                                  val: bagian.id,
                                },
                              ],
                              "gajis",
                              "total_diterima"
                            )
                          }}
                        </td>
                        <td
                          style="border: 1px solid #000"
                          class="bottom-text"
                        ></td>
                        <td class="bottom-text"></td>
                      </tr>
                      <tr></tr>
                    </table>
                    <div class="row" v-if="gajis">
                      <div class="col-12">
                        <p>
                          Terbilang : -----
                          {{
                            formatNumberTerbilang(
                              getSumsColJml(
                                [
                                  {
                                    indexs: ["riwayat_pekerjaan", "cabang_id"],
                                    val: cabang.id,
                                  },
                                  {
                                    indexs: ["riwayat_pekerjaan", "bagian_id"],
                                    val: bagian.id,
                                  },
                                ],
                                "gajis"
                              )
                            )
                          }}
                          Rupiah -----
                        </p>
                      </div>
                      <div class="row" style="text-align: center">
                        <div class="col-4">
                          Perumda Air Minum <br />
                          Tirta Hita Buleleng <br />
                          Menyetujui: <br />
                          <br />

                          <div
                            style="
                              text-decoration: underline;
                              padding-top: 35px;
                            "
                            v-if="pejabatMenyetujui"
                          >
                            {{ pejabatMenyetujui.nama }}
                          </div>

                          Direktur Umum
                        </div>
                        <div class="col-4">
                          <br />
                          <br />

                          Mengetahui:<br />
                          <br />

                          <div
                            style="
                              text-decoration: underline;
                              padding-top: 35px;
                            "
                            v-if="pejabatMengetahui"
                          >
                            {{ pejabatMengetahui.nama }}
                          </div>
                          Kepala Bagian Umum
                        </div>
                        <div class="col-4">
                          <br />
                          <div v-if="gajis">
                            Singaraja,
                            {{ convertTglIndonesia(gajis.gajis[0].created_at) }}
                          </div>

                          Dibuat Oleh:<br />
                          <br />

                          <div
                            style="
                              text-decoration: underline;
                              padding-top: 35px;
                            "
                            v-if="pejabatMembuat"
                          >
                            {{ pejabatMembuat.nama }}
                          </div>
                          Ka. Sub Bag. Personalia
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- /col-12  -->
          </div>
        </div>

        <div v-for="bidang in bidangs" :key="bidang.id">
          <div class="row add-page-break-after">
            <div class="col-12">
              <div class="p-3 mb-3">
                <div class="row">
                  <div class="col-12">
                    <h5 style="font-weight: bold">
                      PERUSAHAAN UMUM DAERAH AIR MINUM
                    </h5>
                    <h5 style="font-weight: bold">TIRTA HITA BULELENG</h5>
                    <h4 class="header-title">
                      <strong
                        >DAFTAR PEMBAYARAN GAJI DAN TUNJANGAN BIDANG
                        {{ toUpper(bidang.nama) }}
                      </strong>
                    </h4>
                    <h5 class="header-periode" style="padding-bottom: 20px">
                      <strong
                        >UNTUK BULAN: {{ printBulanNama() }}
                        {{ printTahun() }}</strong
                      >
                    </h5>

                    <table
                      class="table table-sm table-custom no-margin-br"
                      v-if="gajis"
                    >
                      <thead>
                        <tr class="center-top-text">
                          <th rowspan="3">NO</th>
                          <th rowspan="3" class="col-pegawai">
                            NAMA<br />
                            <br />NIP/NIK<br />JABATAN
                          </th>
                          <th rowspan="3" colspan="2">GOL.</th>
                          <th rowspan="2">GAJI POKOK</th>
                          <th colspan="7" rowspan="1">TUNJANGAN</th>
                          <th colspan="2" rowspan="1">POT. KETIDAKHADIRAN</th>
                          <th rowspan="2">JUMLAH BRUTO</th>
                          <th rowspan="2">TUNJANGAN PPH</th>
                          <th rowspan="2">JUMLAH (14+15)</th>
                          <th rowspan="1" colspan="5">POTONGAN</th>
                          <th rowspan="3">JUMLAH YANG DITERIMA</th>
                          <th rowspan="3" colspan="2">TANDA TANGAN</th>
                        </tr>

                        <tr class="center-top-text">
                          <th>
                            PERUSAHAAN
                            <div class="small-text">(5)x 25%</div>
                          </th>
                          <th>JABATAN</th>
                          <th>
                            KEMAHALAN
                            <div class="small-text">(5)x 5%</div>
                          </th>
                          <th>AIR</th>
                          <th>TRANSPORT</th>
                          <th>PANGAN</th>
                          <th>KESEHATAN</th>
                          <th>HARI</th>
                          <th>
                            JUMLAH
                            <div class="small-text">13X5%(6+10)</div>
                          </th>
                          <th>KESEHATAN</th>
                          <th>
                            BPJS TK 3 PROGRAM
                            <div class="small-text">(15)X2%</div>
                          </th>
                          <th>
                            BPJS TK 4 PROGRAM
                            <div class="small-text">
                              (Bts maxX1% JP)+ 2% JHT
                            </div>
                          </th>
                          <th>PENSIUN JIWASRAYA</th>
                          <th>PPH</th>
                        </tr>

                        <tr class="center-top-text">
                          <th style="border: none">(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                        </tr>
                        <tr class="center-top-text">
                          <th>1</th>
                          <th>2</th>
                          <th>3</th>
                          <th>4</th>
                          <th>5</th>
                          <th>6</th>
                          <th>7</th>
                          <th>8</th>
                          <th>9</th>
                          <th>10</th>
                          <th>11</th>
                          <th>12</th>
                          <th>13</th>
                          <th>14</th>
                          <th>15</th>
                          <th>16</th>
                          <th>17</th>
                          <th>18</th>
                          <th>19</th>
                          <th>20</th>
                          <th>20</th>
                          <th>21</th>
                          <th>22</th>
                          <th></th>
                          <th>24</th>
                        </tr>
                      </thead>
                      <tbody>
                        <!-- TODO -->
                        <tr
                          v-for="(item, index) in filterGajisByConditions(
                            [
                              {
                                indexs: ['riwayat_pekerjaan', 'cabang_id'],
                                val: cabang.id,
                              },
                              {
                                indexs: ['riwayat_pekerjaan', 'bidang_id'],
                                val: bidang.id,
                              },
                            ],
                            'sub_bidang_id',
                            'gajis'
                          )"
                          :key="item.id"
                          :class="getPageBreakStyle(index)"
                        >
                          <!-- :class="'top-text table-row-vfor'"
                            :style="getPageBreakStyle(index)" -->
                          <td style="border: 1px solid #000">
                            <span
                              :style="printNewLine(item.print_sub_bagian)"
                              v-if="subBidangs"
                            >
                            </span>
                            {{ index + 1 }}
                          </td>
                          <td style="border: 1px solid #000">
                            <div
                              :style="boldStyle"
                              v-if="shouldRenderSubBagian"
                            >
                              {{
                                printSubBagian(
                                  item.print_sub_bagian,
                                  item.riwayat_pekerjaan
                                )
                              }}
                            </div>
                            {{ item.pegawai.nama }}
                            <br />NIK.
                            {{ item.pegawai.nik }}
                          </td>
                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            <!-- style="white-space: pre-line" -->
                            {{ item.golongan.nama }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ item.pegawai.status_ptkp }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.gaji_pokok) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.tun_perusahaan) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.tun_jabatan) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.tun_kemahalan) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.tun_air) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.tun_transport) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.tun_pangan) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.tun_kesehatan) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.jml_tdk_hadir) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.pot_5_persen) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.jml_bruto) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.tun_pph) }}
                          </td>
                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.tun_pph + item.jml_bruto) }}
                          </td>
                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.pot_kesehatan) }}
                          </td>
                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.pot_bpjs_tk_tiga_program) }}
                          </td>
                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.pot_bpjs_tk_empat_program) }}
                          </td>
                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.pot_pensiun) }}
                          </td>
                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.pot_pph) }}
                          </td>
                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.total_diterima) }}
                          </td>
                          <td
                            style="border: 1px solid #000"
                            class="bottom-text"
                          >
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ index + 1 }}
                          </td>
                          <td class="bottom-text">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span
                            >...............
                          </td>
                        </tr>
                      </tbody>
                      <!-- <tfoot> -->
                      <tr
                        class="top-text table-row-vfor"
                        v-if="gajis.totalGajis"
                      >
                        <td style="border: 1px solid #000"></td>
                        <td style="border: 1px solid #000; font-weight: bold">
                          JUMLAH
                        </td>
                        <td style="border: 1px solid #000"></td>
                        <td style="border: 1px solid #000"></td>

                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bidang_id"],
                                  val: bidang.id,
                                },
                              ],
                              "gajis",
                              "gaji_pokok"
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bidang_id"],
                                  val: bidang.id,
                                },
                              ],
                              "gajis",
                              "tun_perusahaan"
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bidang_id"],
                                  val: bidang.id,
                                },
                              ],
                              "gajis",
                              "tun_jabatan"
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bidang_id"],
                                  val: bidang.id,
                                },
                              ],
                              "gajis",
                              "tun_kemahalan"
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bidang_id"],
                                  val: bidang.id,
                                },
                              ],
                              "gajis",
                              "tun_air"
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bidang_id"],
                                  val: bidang.id,
                                },
                              ],
                              "gajis",
                              "tun_transport"
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bidang_id"],
                                  val: bidang.id,
                                },
                              ],
                              "gajis",
                              "tun_pangan"
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bidang_id"],
                                  val: bidang.id,
                                },
                              ],
                              "gajis",
                              "tun_kesehatan"
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bidang_id"],
                                  val: bidang.id,
                                },
                              ],
                              "gajis",
                              "jml_tdk_hadir"
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bidang_id"],
                                  val: bidang.id,
                                },
                              ],
                              "gajis",
                              "pot_5_persen"
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bidang_id"],
                                  val: bidang.id,
                                },
                              ],
                              "gajis",
                              "jml_bruto"
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bidang_id"],
                                  val: bidang.id,
                                },
                              ],
                              "gajis",
                              "tun_pph"
                            )
                          }}
                        </td>
                        <td style="border: 1px solid #000">
                          {{
                            getSumsColJml(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bidang_id"],
                                  val: bidang.id,
                                },
                              ],
                              "gajis"
                            )
                          }}

                          <!-- ini bentar otak error -->
                        </td>
                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bidang_id"],
                                  val: bidang.id,
                                },
                              ],
                              "gajis",
                              "pot_kesehatan"
                            )
                          }}
                        </td>
                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bidang_id"],
                                  val: bidang.id,
                                },
                              ],
                              "gajis",
                              "pot_bpjs_tk_tiga_program"
                            )
                          }}
                        </td>
                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bidang_id"],
                                  val: bidang.id,
                                },
                              ],
                              "gajis",
                              "pot_bpjs_tk_empat_program"
                            )
                          }}
                        </td>
                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bidang_id"],
                                  val: bidang.id,
                                },
                              ],
                              "gajis",
                              "pot_pensiun"
                            )
                          }}
                        </td>
                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bidang_id"],
                                  val: bidang.id,
                                },
                              ],
                              "gajis",
                              "pot_pph"
                            )
                          }}
                        </td>
                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bidang_id"],
                                  val: bidang.id,
                                },
                              ],
                              "gajis",
                              "total_diterima"
                            )
                          }}
                        </td>
                        <td
                          style="border: 1px solid #000"
                          class="bottom-text"
                        ></td>
                        <td class="bottom-text"></td>
                      </tr>
                      <tr></tr>
                      <!-- <tr>
                          <td colspan="24" class="no-border-terbilang">
                            Terbilang : -----
                            {{
                              formatNumberTerbilang(
                                gajis.totalGajis.pot_5_persen +
                                  gajis.totalGajis.jml_bruto
                              )
                            }}
                            Rupiah -----
                          </td>
                        </tr> -->
                      <!-- <tr>
                          <td colspan="24" class="no-border-terbilang">
                            <div class="row">
                              <div class="col-6">
                                Terbilang : -----
                                {{
                                  formatNumberTerbilang(
                                    gajis.totalGajis.pot_5_persen +
                                      gajis.totalGajis.jml_bruto
                                  )
                                }}
                                Rupiah -----
                                <br />
                                Perumda Air Minum <br />
                                Tirta Hita Buleleng <br />
                                Menyetujui: <br />
                                <br />
                                <br />
                                <div
                                  style="
                                    text-decoration: underline;
                                    padding-top: 35px;
                                  "
                                  v-if="pejabatMengetahui"
                                >
                                  {{ pejabatMengetahui.nama }}
                                </div>
  
                                Direktur Umum
                              </div> -->
                      <!-- <div class="col-6">
                                <br />
                                <br />
                                <div v-if="gajis">
                                  Singaraja,
                                  {{ convertTgl(gajis.gajis[0].created_at) }}
                                </div>
  
                                Dibuat Oleh:<br />
                                <br />
                                <br />
                                <div
                                  style="
                                    text-decoration: underline;
                                    padding-top: 35px;
                                  "
                                  v-if="pejabatMembuat"
                                >
                                  {{ pejabatMembuat.nama }}
                                </div>
                                Ka. Sub Bag. Personalia
                              </div>
                            </div>
                          </td>
                        </tr> -->
                    </table>
                    <div class="row" v-if="gajis">
                      <div class="col-12">
                        <p>
                          Terbilang : -----
                          {{
                            formatNumberTerbilang(
                              getSumsColJml(
                                [
                                  {
                                    indexs: ["riwayat_pekerjaan", "cabang_id"],
                                    val: cabang.id,
                                  },
                                  {
                                    indexs: ["riwayat_pekerjaan", "bidang_id"],
                                    val: bidang.id,
                                  },
                                ],
                                "gajis"
                              )
                            )
                          }}
                          Rupiah -----
                        </p>
                      </div>
                      <div class="row" style="text-align: center">
                        <div class="col-4">
                          Perumda Air Minum <br />
                          Tirta Hita Buleleng <br />
                          Menyetujui: <br />
                          <br />

                          <div
                            style="
                              text-decoration: underline;
                              padding-top: 35px;
                            "
                            v-if="pejabatMenyetujui"
                          >
                            {{ pejabatMenyetujui.nama }}
                          </div>

                          Direktur Umum
                        </div>
                        <div class="col-4">
                          <br />
                          <br />

                          Mengetahui:<br />
                          <br />

                          <div
                            style="
                              text-decoration: underline;
                              padding-top: 35px;
                            "
                            v-if="pejabatMengetahui"
                          >
                            {{ pejabatMengetahui.nama }}
                          </div>
                          Kepala Bagian Umum
                        </div>
                        <div class="col-4">
                          <br />
                          <div v-if="gajis">
                            Singaraja,
                            {{ convertTglIndonesia(gajis.gajis[0].created_at) }}
                          </div>

                          Dibuat Oleh:<br />
                          <br />

                          <div
                            style="
                              text-decoration: underline;
                              padding-top: 35px;
                            "
                            v-if="pejabatMembuat"
                          >
                            {{ pejabatMembuat.nama }}
                          </div>
                          Ka. Sub Bag. Personalia
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- /col-12  -->
          </div>
        </div>
      </div>
      <!-- end of cabang = 1 -->
      <div v-else>
        <!-- Content for cabang not pusat -->

        <div class="row add-page-break-after">
          <div class="col-12">
            <div class="p-3 mb-3">
              <div class="row">
                <div class="col-12">
                  <h5 style="font-weight: bold">
                    PERUSAHAAN UMUM DAERAH AIR MINUM
                  </h5>
                  <h5 style="font-weight: bold">TIRTA HITA BULELENG</h5>
                  <h4 class="header-title">
                    <strong
                      >DAFTAR PEMBAYARAN GAJI DAN TUNJANGAN CABANG
                      {{ toUpper(cabang.nama) }}
                    </strong>
                  </h4>
                  <h5 class="header-periode" style="padding-bottom: 20px">
                    <strong
                      >UNTUK BULAN: {{ printBulanNama() }}
                      {{ printTahun() }}</strong
                    >
                  </h5>

                  <table
                    class="table table-sm table-custom no-margin-br"
                    v-if="gajis"
                  >
                    <thead>
                      <tr class="center-top-text">
                        <th rowspan="3">NO</th>
                        <th rowspan="3" class="col-pegawai">
                          NAMA<br />
                          <br />NIP/NIK<br />JABATAN
                        </th>
                        <th rowspan="3" colspan="2">GOL.</th>
                        <th rowspan="2">GAJI POKOK</th>
                        <th colspan="7" rowspan="1">TUNJANGAN</th>
                        <th colspan="2" rowspan="1">POT. KETIDAKHADIRAN</th>
                        <th rowspan="2">JUMLAH BRUTO</th>
                        <th rowspan="2">TUNJANGAN PPH</th>
                        <th rowspan="2">JUMLAH (14+15)</th>
                        <th rowspan="1" colspan="5">POTONGAN</th>
                        <th rowspan="3">JUMLAH YANG DITERIMA</th>
                        <th rowspan="3" colspan="2">TANDA TANGAN</th>
                      </tr>

                      <tr class="center-top-text">
                        <th>
                          PERUSAHAAN
                          <div class="small-text">(5)x 25%</div>
                        </th>
                        <th>JABATAN</th>
                        <th>
                          KEMAHALAN
                          <div class="small-text">(5)x 5%</div>
                        </th>
                        <th>AIR</th>
                        <th>TRANSPORT</th>
                        <th>PANGAN</th>
                        <th>KESEHATAN</th>
                        <th>HARI</th>
                        <th>
                          JUMLAH
                          <div class="small-text">13X5%(6+10)</div>
                        </th>
                        <th>KESEHATAN</th>
                        <th>
                          BPJS TK 3 PROGRAM
                          <div class="small-text">(15)X2%</div>
                        </th>
                        <th>
                          BPJS TK 4 PROGRAM
                          <div class="small-text">(Bts maxX1% JP)+ 2% JHT</div>
                        </th>
                        <th>PENSIUN JIWASRAYA</th>
                        <th>PPH</th>
                      </tr>

                      <tr class="center-top-text">
                        <th style="border: none">(Rp.)</th>
                        <th>(Rp.)</th>
                        <th>(Rp.)</th>
                        <th>(Rp.)</th>
                        <th>(Rp.)</th>
                        <th>(Rp.)</th>
                        <th>(Rp.)</th>
                        <th>(Rp.)</th>
                        <th>(Rp.)</th>
                        <th>(Rp.)</th>
                        <th>(Rp.)</th>
                        <th>(Rp.)</th>
                        <th>(Rp.)</th>
                        <th>(Rp.)</th>
                        <th>(Rp.)</th>
                        <th>(Rp.)</th>
                        <th>(Rp.)</th>
                        <th>(Rp.)</th>
                      </tr>
                      <tr class="center-top-text">
                        <th>1</th>
                        <th>2</th>
                        <th>3</th>
                        <th>4</th>
                        <th>5</th>
                        <th>6</th>
                        <th>7</th>
                        <th>8</th>
                        <th>9</th>
                        <th>10</th>
                        <th>11</th>
                        <th>12</th>
                        <th>13</th>
                        <th>14</th>
                        <th>15</th>
                        <th>16</th>
                        <th>17</th>
                        <th>18</th>
                        <th>19</th>
                        <th>20</th>
                        <th>20</th>
                        <th>21</th>
                        <th>22</th>
                        <th></th>
                        <th>24</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, index) in filterGajisByConditions(
                          [
                            {
                              indexs: ['riwayat_pekerjaan', 'cabang_id'],
                              val: cabang.id,
                            },
                            {
                              indexs: ['riwayat_pekerjaan', 'unit_id'],
                              val: null,
                            },
                          ],
                          'seksi_id',
                          'gajis'
                        )"
                        :key="item.id"
                        :class="getPageBreakStyle(index)"
                      >
                        <td style="border: 1px solid #000">
                          <span
                            :style="printNewLine(item.print_sub_bagian)"
                            v-if="subBagians"
                          >
                          </span>
                          {{ index + 1 }}
                        </td>
                        <!-- ini adalah gaji di cabang -->
                        <td style="border: 1px solid #000">
                          <div :style="boldStyle" v-if="shouldRenderSubBagian">
                            {{
                              printSubBagian(
                                item.print_sub_bagian,
                                item.riwayat_pekerjaan,
                                "dariCabang"
                              )
                            }}
                          </div>
                          {{ item.pegawai.nama }}
                          <br />NIK.
                          {{ item.pegawai.nik }}
                        </td>
                        <td style="border: 1px solid #000">
                          <span :style="printNewLine(item.print_sub_bagian)">
                          </span>
                          {{ item.golongan.nama }}
                        </td>

                        <td style="border: 1px solid #000">
                          <span :style="printNewLine(item.print_sub_bagian)">
                          </span>
                          {{ item.pegawai.status_ptkp }}
                        </td>

                        <td style="border: 1px solid #000">
                          <span :style="printNewLine(item.print_sub_bagian)">
                          </span>
                          {{ formatNumber(item.gaji_pokok) }}
                        </td>

                        <td style="border: 1px solid #000">
                          <span :style="printNewLine(item.print_sub_bagian)">
                          </span>
                          {{ formatNumber(item.tun_perusahaan) }}
                        </td>

                        <td style="border: 1px solid #000">
                          <span :style="printNewLine(item.print_sub_bagian)">
                          </span>
                          {{ formatNumber(item.tun_jabatan) }}
                        </td>

                        <td style="border: 1px solid #000">
                          <span :style="printNewLine(item.print_sub_bagian)">
                          </span>
                          {{ formatNumber(item.tun_kemahalan) }}
                        </td>

                        <td style="border: 1px solid #000">
                          <span :style="printNewLine(item.print_sub_bagian)">
                          </span>
                          {{ formatNumber(item.tun_air) }}
                        </td>

                        <td style="border: 1px solid #000">
                          <span :style="printNewLine(item.print_sub_bagian)">
                          </span>
                          {{ formatNumber(item.tun_transport) }}
                        </td>

                        <td style="border: 1px solid #000">
                          <span :style="printNewLine(item.print_sub_bagian)">
                          </span>
                          {{ formatNumber(item.tun_pangan) }}
                        </td>

                        <td style="border: 1px solid #000">
                          <span :style="printNewLine(item.print_sub_bagian)">
                          </span>
                          {{ formatNumber(item.tun_kesehatan) }}
                        </td>

                        <td style="border: 1px solid #000">
                          <span :style="printNewLine(item.print_sub_bagian)">
                          </span>
                          {{ formatNumber(item.jml_tdk_hadir) }}
                        </td>

                        <td style="border: 1px solid #000">
                          <span :style="printNewLine(item.print_sub_bagian)">
                          </span>
                          {{ formatNumber(item.pot_5_persen) }}
                        </td>

                        <td style="border: 1px solid #000">
                          <span :style="printNewLine(item.print_sub_bagian)">
                          </span>
                          {{ formatNumber(item.jml_bruto) }}
                        </td>

                        <td style="border: 1px solid #000">
                          <span :style="printNewLine(item.print_sub_bagian)">
                          </span>
                          {{ formatNumber(item.tun_pph) }}
                        </td>
                        <td style="border: 1px solid #000">
                          <span :style="printNewLine(item.print_sub_bagian)">
                          </span>
                          {{ formatNumber(item.tun_pph + item.jml_bruto) }}
                        </td>
                        <td style="border: 1px solid #000">
                          <span :style="printNewLine(item.print_sub_bagian)">
                          </span>
                          {{ formatNumber(item.pot_kesehatan) }}
                        </td>
                        <td style="border: 1px solid #000">
                          <span :style="printNewLine(item.print_sub_bagian)">
                          </span>
                          {{ formatNumber(item.pot_bpjs_tk_tiga_program) }}
                        </td>
                        <td style="border: 1px solid #000">
                          <span :style="printNewLine(item.print_sub_bagian)">
                          </span>
                          {{ formatNumber(item.pot_bpjs_tk_empat_program) }}
                        </td>
                        <td style="border: 1px solid #000">
                          <span :style="printNewLine(item.print_sub_bagian)">
                          </span>
                          {{ formatNumber(item.pot_pensiun) }}
                        </td>
                        <td style="border: 1px solid #000">
                          <span :style="printNewLine(item.print_sub_bagian)">
                          </span>
                          {{ formatNumber(item.pot_pph) }}
                        </td>
                        <td style="border: 1px solid #000">
                          <span :style="printNewLine(item.print_sub_bagian)">
                          </span>
                          {{ formatNumber(item.total_diterima) }}
                        </td>
                        <td style="border: 1px solid #000" class="bottom-text">
                          <span :style="printNewLine(item.print_sub_bagian)">
                          </span>
                          {{ index + 1 }}
                        </td>
                        <td class="bottom-text">
                          <span :style="printNewLine(item.print_sub_bagian)">
                          </span
                          >...............
                        </td>
                      </tr>
                    </tbody>

                    <tr class="top-text table-row-vfor" v-if="gajis.totalGajis">
                      <td style="border: 1px solid #000"></td>
                      <td style="border: 1px solid #000; font-weight: bold">
                        JUMLAH
                      </td>
                      <td style="border: 1px solid #000"></td>
                      <td style="border: 1px solid #000"></td>

                      <td style="border: 1px solid #000">
                        {{
                          getSums(
                            [
                              {
                                indexs: ["riwayat_pekerjaan", "cabang_id"],
                                val: cabang.id,
                              },
                            ],
                            "gajis",
                            "gaji_pokok"
                          )
                        }}
                      </td>

                      <td style="border: 1px solid #000">
                        {{
                          getSums(
                            [
                              {
                                indexs: ["riwayat_pekerjaan", "cabang_id"],
                                val: cabang.id,
                              },
                            ],
                            "gajis",
                            "tun_perusahaan"
                          )
                        }}
                      </td>

                      <td style="border: 1px solid #000">
                        {{
                          getSums(
                            [
                              {
                                indexs: ["riwayat_pekerjaan", "cabang_id"],
                                val: cabang.id,
                              },
                            ],
                            "gajis",
                            "tun_jabatan"
                          )
                        }}
                      </td>

                      <td style="border: 1px solid #000">
                        {{
                          getSums(
                            [
                              {
                                indexs: ["riwayat_pekerjaan", "cabang_id"],
                                val: cabang.id,
                              },
                            ],
                            "gajis",
                            "tun_kemahalan"
                          )
                        }}
                      </td>

                      <td style="border: 1px solid #000">
                        {{
                          getSums(
                            [
                              {
                                indexs: ["riwayat_pekerjaan", "cabang_id"],
                                val: cabang.id,
                              },
                            ],
                            "gajis",
                            "tun_air"
                          )
                        }}
                      </td>

                      <td style="border: 1px solid #000">
                        {{
                          getSums(
                            [
                              {
                                indexs: ["riwayat_pekerjaan", "cabang_id"],
                                val: cabang.id,
                              },
                            ],
                            "gajis",
                            "tun_transport"
                          )
                        }}
                      </td>

                      <td style="border: 1px solid #000">
                        {{
                          getSums(
                            [
                              {
                                indexs: ["riwayat_pekerjaan", "cabang_id"],
                                val: cabang.id,
                              },
                            ],
                            "gajis",
                            "tun_pangan"
                          )
                        }}
                      </td>

                      <td style="border: 1px solid #000">
                        {{
                          getSums(
                            [
                              {
                                indexs: ["riwayat_pekerjaan", "cabang_id"],
                                val: cabang.id,
                              },
                            ],
                            "gajis",
                            "tun_kesehatan"
                          )
                        }}
                      </td>

                      <td style="border: 1px solid #000">
                        {{
                          getSums(
                            [
                              {
                                indexs: ["riwayat_pekerjaan", "cabang_id"],
                                val: cabang.id,
                              },
                            ],
                            "gajis",
                            "jml_tdk_hadir"
                          )
                        }}
                      </td>

                      <td style="border: 1px solid #000">
                        {{
                          getSums(
                            [
                              {
                                indexs: ["riwayat_pekerjaan", "cabang_id"],
                                val: cabang.id,
                              },
                            ],
                            "gajis",
                            "pot_5_persen"
                          )
                        }}
                      </td>

                      <td style="border: 1px solid #000">
                        {{
                          getSums(
                            [
                              {
                                indexs: ["riwayat_pekerjaan", "cabang_id"],
                                val: cabang.id,
                              },
                            ],
                            "gajis",
                            "jml_bruto"
                          )
                        }}
                      </td>

                      <td style="border: 1px solid #000">
                        {{
                          getSums(
                            [
                              {
                                indexs: ["riwayat_pekerjaan", "cabang_id"],
                                val: cabang.id,
                              },
                            ],
                            "gajis",
                            "tun_pph"
                          )
                        }}
                      </td>
                      <td style="border: 1px solid #000">
                        {{
                          getSumsColJml(
                            [
                              {
                                indexs: ["riwayat_pekerjaan", "cabang_id"],
                                val: cabang.id,
                              },
                            ],
                            "gajis"
                          )
                        }}

                        <!-- ini bentar otak error -->
                      </td>
                      <td style="border: 1px solid #000">
                        {{
                          getSums(
                            [
                              {
                                indexs: ["riwayat_pekerjaan", "cabang_id"],
                                val: cabang.id,
                              },
                            ],
                            "gajis",
                            "pot_kesehatan"
                          )
                        }}
                      </td>
                      <td style="border: 1px solid #000">
                        {{
                          getSums(
                            [
                              {
                                indexs: ["riwayat_pekerjaan", "cabang_id"],
                                val: cabang.id,
                              },
                            ],
                            "gajis",
                            "pot_bpjs_tk_tiga_program"
                          )
                        }}
                      </td>
                      <td style="border: 1px solid #000">
                        {{
                          getSums(
                            [
                              {
                                indexs: ["riwayat_pekerjaan", "cabang_id"],
                                val: cabang.id,
                              },
                            ],
                            "gajis",
                            "pot_bpjs_tk_empat_program"
                          )
                        }}
                      </td>
                      <td style="border: 1px solid #000">
                        {{
                          getSums(
                            [
                              {
                                indexs: ["riwayat_pekerjaan", "cabang_id"],
                                val: cabang.id,
                              },
                            ],
                            "gajis",
                            "pot_pensiun"
                          )
                        }}
                      </td>
                      <td style="border: 1px solid #000">
                        {{
                          getSums(
                            [
                              {
                                indexs: ["riwayat_pekerjaan", "cabang_id"],
                                val: cabang.id,
                              },
                            ],
                            "gajis",
                            "pot_pph"
                          )
                        }}
                      </td>
                      <td style="border: 1px solid #000">
                        {{
                          getSums(
                            [
                              {
                                indexs: ["riwayat_pekerjaan", "cabang_id"],
                                val: cabang.id,
                              },
                            ],
                            "gajis",
                            "total_diterima"
                          )
                        }}
                      </td>
                      <td
                        style="border: 1px solid #000"
                        class="bottom-text"
                      ></td>
                      <td class="bottom-text"></td>
                    </tr>
                    <tr></tr>
                  </table>
                  <div class="row" v-if="gajis">
                    <div class="col-12">
                      <p>
                        Terbilang : -----
                        {{
                          formatNumberTerbilang(
                            getSumsColJml(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                              ],
                              "gajis"
                            )
                          )
                        }}
                        Rupiah -----
                      </p>
                    </div>
                    <div class="row" style="text-align: center">
                      <div class="col-4">
                        Perumda Air Minum <br />
                        Tirta Hita Buleleng <br />
                        Menyetujui: <br />
                        <br />

                        <div
                          style="text-decoration: underline; padding-top: 35px"
                          v-if="pejabatMenyetujui"
                        >
                          {{ pejabatMenyetujui.nama }}
                        </div>

                        Direktur Umum
                      </div>
                      <div class="col-4">
                        <br />
                        <br />

                        Mengetahui:<br />
                        <br />

                        <div
                          style="text-decoration: underline; padding-top: 35px"
                          v-if="pejabatMengetahui"
                        >
                          {{ pejabatMengetahui.nama }}
                        </div>
                        Kepala Bagian Umum
                      </div>
                      <div class="col-4">
                        <br />
                        <div v-if="gajis">
                          Singaraja,
                          {{ convertTglIndonesia(gajis.gajis[0].created_at) }}
                        </div>

                        Dibuat Oleh:<br />
                        <br />

                        <div
                          style="text-decoration: underline; padding-top: 35px"
                          v-if="pejabatMembuat"
                        >
                          {{ pejabatMembuat.nama }}
                        </div>
                        Ka. Sub Bag. Personalia
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /col-12  -->
        </div>
      </div>
    </div>
    <!-- /v-for cabangs TETAP -->

    <div v-for="unit in units" :key="unit.id">
      <div class="row add-page-break-after">
        <div class="col-12">
          <div class="p-3 mb-3">
            <div class="row">
              <div class="col-12">
                <h5 style="font-weight: bold">
                  PERUSAHAAN UMUM DAERAH AIR MINUM
                </h5>
                <h5 style="font-weight: bold">TIRTA HITA BULELENG</h5>
                <h4 class="header-title">
                  <strong
                    >DAFTAR PEMBAYARAN GAJI DAN TUNJANGAN CABANG
                    <!-- {{ toUpper(unit.cabang.nama) }}  -->
                    UNIT
                    {{ toUpper(unit.nama) }}
                  </strong>
                </h4>
                <h5 class="header-periode" style="padding-bottom: 20px">
                  <strong
                    >UNTUK BULAN: {{ printBulanNama() }}
                    {{ printTahun() }}</strong
                  >
                </h5>

                <table
                  class="table table-sm table-custom no-margin-br"
                  v-if="gajis"
                >
                  <thead>
                    <tr class="center-top-text">
                      <th rowspan="3">NO</th>
                      <th rowspan="3" class="col-pegawai">
                        NAMA<br />
                        <br />NIP/NIK<br />JABATAN
                      </th>
                      <th rowspan="3" colspan="2">GOL.</th>
                      <th rowspan="2">GAJI POKOK</th>
                      <th colspan="7" rowspan="1">TUNJANGAN</th>
                      <th colspan="2" rowspan="1">POT. KETIDAKHADIRAN</th>
                      <th rowspan="2">JUMLAH BRUTO</th>
                      <th rowspan="2">TUNJANGAN PPH</th>
                      <th rowspan="2">JUMLAH (14+15)</th>
                      <th rowspan="1" colspan="5">POTONGAN</th>
                      <th rowspan="3">JUMLAH YANG DITERIMA</th>
                      <th rowspan="3" colspan="2">TANDA TANGAN</th>
                    </tr>

                    <tr class="center-top-text">
                      <th>
                        PERUSAHAAN
                        <div class="small-text">(5)x 25%</div>
                      </th>
                      <th>JABATAN</th>
                      <th>
                        KEMAHALAN
                        <div class="small-text">(5)x 5%</div>
                      </th>
                      <th>AIR</th>
                      <th>TRANSPORT</th>
                      <th>PANGAN</th>
                      <th>KESEHATAN</th>
                      <th>HARI</th>
                      <th>
                        JUMLAH
                        <div class="small-text">13X5%(6+10)</div>
                      </th>
                      <th>KESEHATAN</th>
                      <th>
                        BPJS TK 3 PROGRAM
                        <div class="small-text">(15)X2%</div>
                      </th>
                      <th>
                        BPJS TK 4 PROGRAM
                        <div class="small-text">(Bts maxX1% JP)+ 2% JHT</div>
                      </th>
                      <th>PENSIUN JIWASRAYA</th>
                      <th>PPH</th>
                    </tr>

                    <tr class="center-top-text">
                      <th style="border: none">(Rp.)</th>
                      <th>(Rp.)</th>
                      <th>(Rp.)</th>
                      <th>(Rp.)</th>
                      <th>(Rp.)</th>
                      <th>(Rp.)</th>
                      <th>(Rp.)</th>
                      <th>(Rp.)</th>
                      <th>(Rp.)</th>
                      <th>(Rp.)</th>
                      <th>(Rp.)</th>
                      <th>(Rp.)</th>
                      <th>(Rp.)</th>
                      <th>(Rp.)</th>
                      <th>(Rp.)</th>
                      <th>(Rp.)</th>
                      <th>(Rp.)</th>
                      <th>(Rp.)</th>
                    </tr>
                    <tr class="center-top-text">
                      <th>1</th>
                      <th>2</th>
                      <th>3</th>
                      <th>4</th>
                      <th>5</th>
                      <th>6</th>
                      <th>7</th>
                      <th>8</th>
                      <th>9</th>
                      <th>10</th>
                      <th>11</th>
                      <th>12</th>
                      <th>13</th>
                      <th>14</th>
                      <th>15</th>
                      <th>16</th>
                      <th>17</th>
                      <th>18</th>
                      <th>19</th>
                      <th>20</th>
                      <th>20</th>
                      <th>21</th>
                      <th>22</th>
                      <th></th>
                      <th>24</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in filterGajisByConditions(
                        [
                          {
                            indexs: ['riwayat_pekerjaan', 'unit_id'],
                            val: unit.id,
                          },
                        ],
                        '',
                        'gajis'
                      )"
                      :key="item.id"
                      :class="getPageBreakStyle(index)"
                    >
                      <td style="border: 1px solid #000">
                        <span
                          :style="printNewLine(item.print_sub_bagian)"
                          v-if="subBagians"
                        >
                        </span>
                        {{ index + 1 }}
                      </td>
                      <td style="border: 1px solid #000">
                        <div :style="boldStyle" v-if="shouldRenderSubBagian">
                          {{
                            printSubBagian(
                              item.print_sub_bagian,
                              item.riwayat_pekerjaan
                            )
                          }}
                        </div>
                        {{ item.pegawai.nama }}
                        <br />NIK.
                        {{ item.pegawai.nik }}
                      </td>
                      <td style="border: 1px solid #000">
                        <span :style="printNewLine(item.print_sub_bagian)">
                        </span>
                        {{ item.golongan.nama }}
                      </td>

                      <td style="border: 1px solid #000">
                        <span :style="printNewLine(item.print_sub_bagian)">
                        </span>
                        {{ item.pegawai.status_ptkp }}
                      </td>

                      <td style="border: 1px solid #000">
                        <span :style="printNewLine(item.print_sub_bagian)">
                        </span>
                        {{ formatNumber(item.gaji_pokok) }}
                      </td>

                      <td style="border: 1px solid #000">
                        <span :style="printNewLine(item.print_sub_bagian)">
                        </span>
                        {{ formatNumber(item.tun_perusahaan) }}
                      </td>

                      <td style="border: 1px solid #000">
                        <span :style="printNewLine(item.print_sub_bagian)">
                        </span>
                        {{ formatNumber(item.tun_jabatan) }}
                      </td>

                      <td style="border: 1px solid #000">
                        <span :style="printNewLine(item.print_sub_bagian)">
                        </span>
                        {{ formatNumber(item.tun_kemahalan) }}
                      </td>

                      <td style="border: 1px solid #000">
                        <span :style="printNewLine(item.print_sub_bagian)">
                        </span>
                        {{ formatNumber(item.tun_air) }}
                      </td>

                      <td style="border: 1px solid #000">
                        <span :style="printNewLine(item.print_sub_bagian)">
                        </span>
                        {{ formatNumber(item.tun_transport) }}
                      </td>

                      <td style="border: 1px solid #000">
                        <span :style="printNewLine(item.print_sub_bagian)">
                        </span>
                        {{ formatNumber(item.tun_pangan) }}
                      </td>

                      <td style="border: 1px solid #000">
                        <span :style="printNewLine(item.print_sub_bagian)">
                        </span>
                        {{ formatNumber(item.tun_kesehatan) }}
                      </td>

                      <td style="border: 1px solid #000">
                        <span :style="printNewLine(item.print_sub_bagian)">
                        </span>
                        {{ formatNumber(item.jml_tdk_hadir) }}
                      </td>

                      <td style="border: 1px solid #000">
                        <span :style="printNewLine(item.print_sub_bagian)">
                        </span>
                        {{ formatNumber(item.pot_5_persen) }}
                      </td>

                      <td style="border: 1px solid #000">
                        <span :style="printNewLine(item.print_sub_bagian)">
                        </span>
                        {{ formatNumber(item.jml_bruto) }}
                      </td>

                      <td style="border: 1px solid #000">
                        <span :style="printNewLine(item.print_sub_bagian)">
                        </span>
                        {{ formatNumber(item.tun_pph) }}
                      </td>
                      <td style="border: 1px solid #000">
                        <span :style="printNewLine(item.print_sub_bagian)">
                        </span>
                        {{ formatNumber(item.tun_pph + item.jml_bruto) }}
                      </td>
                      <td style="border: 1px solid #000">
                        <span :style="printNewLine(item.print_sub_bagian)">
                        </span>
                        {{ formatNumber(item.pot_kesehatan) }}
                      </td>
                      <td style="border: 1px solid #000">
                        <span :style="printNewLine(item.print_sub_bagian)">
                        </span>
                        {{ formatNumber(item.pot_bpjs_tk_tiga_program) }}
                      </td>
                      <td style="border: 1px solid #000">
                        <span :style="printNewLine(item.print_sub_bagian)">
                        </span>
                        {{ formatNumber(item.pot_bpjs_tk_empat_program) }}
                      </td>
                      <td style="border: 1px solid #000">
                        <span :style="printNewLine(item.print_sub_bagian)">
                        </span>
                        {{ formatNumber(item.pot_pensiun) }}
                      </td>
                      <td style="border: 1px solid #000">
                        <span :style="printNewLine(item.print_sub_bagian)">
                        </span>
                        {{ formatNumber(item.pot_pph) }}
                      </td>
                      <td style="border: 1px solid #000">
                        <span :style="printNewLine(item.print_sub_bagian)">
                        </span>
                        {{ formatNumber(item.total_diterima) }}
                      </td>
                      <td style="border: 1px solid #000" class="bottom-text">
                        <span :style="printNewLine(item.print_sub_bagian)">
                        </span>
                        {{ index + 1 }}
                      </td>
                      <td class="bottom-text">
                        <span :style="printNewLine(item.print_sub_bagian)">
                        </span
                        >...............
                      </td>
                    </tr>
                  </tbody>

                  <tr class="top-text table-row-vfor" v-if="gajis.totalGajis">
                    <td style="border: 1px solid #000"></td>
                    <td style="border: 1px solid #000; font-weight: bold">
                      JUMLAH
                    </td>
                    <td style="border: 1px solid #000"></td>
                    <td style="border: 1px solid #000"></td>

                    <td style="border: 1px solid #000">
                      {{
                        getSums(
                          [
                            {
                              indexs: ["riwayat_pekerjaan", "unit_id"],
                              val: unit.id,
                            },
                          ],
                          "gajis",
                          "gaji_pokok"
                        )
                      }}
                    </td>

                    <td style="border: 1px solid #000">
                      {{
                        getSums(
                          [
                            {
                              indexs: ["riwayat_pekerjaan", "unit_id"],
                              val: unit.id,
                            },
                          ],
                          "gajis",
                          "tun_perusahaan"
                        )
                      }}
                    </td>

                    <td style="border: 1px solid #000">
                      {{
                        getSums(
                          [
                            {
                              indexs: ["riwayat_pekerjaan", "unit_id"],
                              val: unit.id,
                            },
                          ],
                          "gajis",
                          "tun_jabatan"
                        )
                      }}
                    </td>

                    <td style="border: 1px solid #000">
                      {{
                        getSums(
                          [
                            {
                              indexs: ["riwayat_pekerjaan", "unit_id"],
                              val: unit.id,
                            },
                          ],
                          "gajis",
                          "tun_kemahalan"
                        )
                      }}
                    </td>

                    <td style="border: 1px solid #000">
                      {{
                        getSums(
                          [
                            {
                              indexs: ["riwayat_pekerjaan", "unit_id"],
                              val: unit.id,
                            },
                          ],
                          "gajis",
                          "tun_air"
                        )
                      }}
                    </td>

                    <td style="border: 1px solid #000">
                      {{
                        getSums(
                          [
                            {
                              indexs: ["riwayat_pekerjaan", "unit_id"],
                              val: unit.id,
                            },
                          ],
                          "gajis",
                          "tun_transport"
                        )
                      }}
                    </td>

                    <td style="border: 1px solid #000">
                      {{
                        getSums(
                          [
                            {
                              indexs: ["riwayat_pekerjaan", "unit_id"],
                              val: unit.id,
                            },
                          ],
                          "gajis",
                          "tun_pangan"
                        )
                      }}
                    </td>

                    <td style="border: 1px solid #000">
                      {{
                        getSums(
                          [
                            {
                              indexs: ["riwayat_pekerjaan", "unit_id"],
                              val: unit.id,
                            },
                          ],
                          "gajis",
                          "tun_kesehatan"
                        )
                      }}
                    </td>

                    <td style="border: 1px solid #000">
                      {{
                        getSums(
                          [
                            {
                              indexs: ["riwayat_pekerjaan", "unit_id"],
                              val: unit.id,
                            },
                          ],
                          "gajis",
                          "jml_tdk_hadir"
                        )
                      }}
                    </td>

                    <td style="border: 1px solid #000">
                      {{
                        getSums(
                          [
                            {
                              indexs: ["riwayat_pekerjaan", "unit_id"],
                              val: unit.id,
                            },
                          ],
                          "gajis",
                          "pot_5_persen"
                        )
                      }}
                    </td>

                    <td style="border: 1px solid #000">
                      {{
                        getSums(
                          [
                            {
                              indexs: ["riwayat_pekerjaan", "unit_id"],
                              val: unit.id,
                            },
                          ],
                          "gajis",
                          "jml_bruto"
                        )
                      }}
                    </td>

                    <td style="border: 1px solid #000">
                      {{
                        getSums(
                          [
                            {
                              indexs: ["riwayat_pekerjaan", "unit_id"],
                              val: unit.id,
                            },
                          ],
                          "gajis",
                          "tun_pph"
                        )
                      }}
                    </td>
                    <td style="border: 1px solid #000">
                      {{
                        getSumsColJml(
                          [
                            {
                              indexs: ["riwayat_pekerjaan", "unit_id"],
                              val: unit.id,
                            },
                          ],
                          "gajis"
                        )
                      }}

                      <!-- ini bentar otak error -->
                    </td>
                    <td style="border: 1px solid #000">
                      {{
                        getSums(
                          [
                            {
                              indexs: ["riwayat_pekerjaan", "unit_id"],
                              val: unit.id,
                            },
                          ],
                          "gajis",
                          "pot_kesehatan"
                        )
                      }}
                    </td>
                    <td style="border: 1px solid #000">
                      {{
                        getSums(
                          [
                            {
                              indexs: ["riwayat_pekerjaan", "unit_id"],
                              val: unit.id,
                            },
                          ],
                          "gajis",
                          "pot_bpjs_tk_tiga_program"
                        )
                      }}
                    </td>
                    <td style="border: 1px solid #000">
                      {{
                        getSums(
                          [
                            {
                              indexs: ["riwayat_pekerjaan", "unit_id"],
                              val: unit.id,
                            },
                          ],
                          "gajis",
                          "pot_bpjs_tk_empat_program"
                        )
                      }}
                    </td>
                    <td style="border: 1px solid #000">
                      {{
                        getSums(
                          [
                            {
                              indexs: ["riwayat_pekerjaan", "unit_id"],
                              val: unit.id,
                            },
                          ],
                          "gajis",
                          "pot_pensiun"
                        )
                      }}
                    </td>
                    <td style="border: 1px solid #000">
                      {{
                        getSums(
                          [
                            {
                              indexs: ["riwayat_pekerjaan", "unit_id"],
                              val: unit.id,
                            },
                          ],
                          "gajis",
                          "pot_pph"
                        )
                      }}
                    </td>
                    <td style="border: 1px solid #000">
                      {{
                        getSums(
                          [
                            {
                              indexs: ["riwayat_pekerjaan", "unit_id"],
                              val: unit.id,
                            },
                          ],
                          "gajis",
                          "total_diterima"
                        )
                      }}
                    </td>
                    <td style="border: 1px solid #000" class="bottom-text"></td>
                    <td class="bottom-text"></td>
                  </tr>
                  <tr></tr>
                </table>
                <div class="row" v-if="gajis">
                  <div class="col-12">
                    <p>
                      Terbilang : -----
                      {{
                        formatNumberTerbilang(
                          getSumsColJml(
                            [
                              {
                                indexs: ["riwayat_pekerjaan", "unit_id"],
                                val: unit.id,
                              },
                            ],
                            "gajis"
                          )
                        )
                      }}
                      Rupiah -----
                    </p>
                  </div>
                  <div class="row" style="text-align: center">
                    <div class="col-4">
                      Perumda Air Minum <br />
                      Tirta Hita Buleleng <br />
                      Menyetujui: <br />
                      <br />

                      <div
                        style="text-decoration: underline; padding-top: 35px"
                        v-if="pejabatMenyetujui"
                      >
                        {{ pejabatMenyetujui.nama }}
                      </div>

                      Direktur Umum
                    </div>
                    <div class="col-4">
                      <br />
                      <br />

                      Mengetahui:<br />
                      <br />

                      <div
                        style="text-decoration: underline; padding-top: 35px"
                        v-if="pejabatMengetahui"
                      >
                        {{ pejabatMengetahui.nama }}
                      </div>
                      Kepala Bagian Umum
                    </div>
                    <div class="col-4">
                      <br />
                      <div v-if="gajis">
                        Singaraja,
                        {{ convertTglIndonesia(gajis.gajis[0].created_at) }}
                      </div>

                      Dibuat Oleh:<br />
                      <br />

                      <div
                        style="text-decoration: underline; padding-top: 35px"
                        v-if="pejabatMembuat"
                      >
                        {{ pejabatMembuat.nama }}
                      </div>
                      Ka. Sub Bag. Personalia
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /col-12  -->
      </div>
    </div>

    <!-- /////////////////////////////////HONOR//////////////////////////////////////////// -->
    <div v-if="gajisHonor">
      <div v-for="(cabang, cabangIndex) in cabangs" :key="cabang.id">
        <div
          v-if="
            shouldPrintGaji(
              [
                {
                  indexs: ['riwayat_pekerjaan', 'cabang_id'],
                  val: cabang.id,
                },
                {
                  indexs: ['riwayat_pekerjaan', 'unit_id'],
                  val: null,
                },
              ],
              'gajisHonor'
            ) !== 'skip'
          "
        >
          <div class="row add-page-break-before">
            <div class="col-12">
              <div class="p-3 mb-3">
                <div class="row">
                  <div class="col-12">
                    <h4 class="header-title">
                      <strong
                        >HONORARIUM TENAGA HONOR KANTOR
                        {{ toUpper(cabang.nama) }}
                      </strong>
                    </h4>
                    <h5 class="header-periode" style="padding-bottom: 20px">
                      <strong
                        >UNTUK BULAN: {{ printBulanNama() }}
                        {{ printTahun() }}</strong
                      >
                    </h5>

                    <table class="table table-sm table-custom no-margin-br">
                      <thead>
                        <tr class="center-top-text">
                          <th rowspan="3">NO</th>
                          <th rowspan="3" class="col-pegawai">NAMA</th>
                          <th rowspan="3">GOL.</th>
                          <th rowspan="3">JABATAN</th>
                          <th rowspan="3">MASA KERJA</th>
                          <th rowspan="3">TMT KONTRAK</th>
                          <th rowspan="2">HONOR (UMK)</th>
                          <th rowspan="2">
                            KENAIKAN MASA KERJA
                            <div class="small-text">(MK x 3% x UMK)</div>
                          </th>
                          <th rowspan="2">TUNJ. KESEHATAN</th>
                          <th rowspan="3">JML TIDAK MASUK</th>
                          <th rowspan="2">
                            POT.
                            <div class="small-text">(5%x6)9</div>
                          </th>
                          <th rowspan="2">JUMLAH BRUTO</th>
                          <th rowspan="1" colspan="2">POTONGAN</th>
                          <th rowspan="2">HONOR DITERIMA</th>
                          <th rowspan="3" colspan="2">TANDA TANGAN</th>
                        </tr>

                        <tr class="center-top-text">
                          <th>KESEHATAN</th>
                          <th>BPJS</th>
                        </tr>

                        <tr class="center-top-text">
                          <th style="border: none">(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                        </tr>
                        <tr class="center-top-text">
                          <th>1</th>
                          <th>2</th>
                          <th>3</th>
                          <th>4</th>
                          <th>5</th>
                          <th>6</th>
                          <th>7</th>
                          <th>8</th>
                          <th>9</th>
                          <th>10</th>
                          <th>11</th>
                          <th>12</th>
                          <th>13</th>
                          <th>14</th>
                          <th>15</th>
                          <th>16</th>
                          <th>17</th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr
                          v-for="(item, index) in filterGajisByConditions(
                            [
                              {
                                indexs: ['riwayat_pekerjaan', 'cabang_id'],
                                val: cabang.id,
                              },
                              {
                                indexs: ['riwayat_pekerjaan', 'unit_id'],
                                val: null,
                              },
                            ],
                            '',
                            'gajisHonor'
                          )"
                          :key="item.id"
                          :class="getPageBreakStyleHonorKontrak(index)"
                        >
                          <!-- :class="'top-text table-row-vfor'"
                            :style="getPageBreakStyle(index)" -->
                          <td
                            style="border: 1px solid #000"
                            :ref="'refTdHonor-' + cabangIndex + '-' + index"
                          >
                            <!-- {{ callPrintIndexHonorKontrak(cabangIndex, index) }} -->
                            <!-- {{ printResults[(cabangIndex, index)] }} -->
                            <!-- {{ printIndexHonorKontrak(index) }} -->
                            <!-- <div v-if="printIndexComputed(index)"></div> -->
                            <!-- {{ printIndexComputed() }} -->
                            {{ printRefTdHonor(cabangIndex, index) }}
                          </td>
                          <td style="border: 1px solid #000">
                            <!-- {{ item.pegawai.nama }} -->
                            {{ item.pegawai.nama }}
                          </td>
                          <td style="border: 1px solid #000">
                            <!-- {{ item.golongan.nama }} PERBAIKI GAJI YAA KARENA JUNI TIDAK ADA GOLONGAN_ID-->
                          </td>

                          <td style="border: 1px solid #000">
                            <div v-if="shouldRenderSubBagian">
                              {{
                                printJabatanHonorKontrak(item.riwayat_pekerjaan)
                              }}
                            </div>
                          </td>

                          <td style="border: 1px solid #000">
                            {{ printMasaKerjaHonorKontrak(item) }}
                          </td>

                          <td style="border: 1px solid #000">
                            {{
                              convertTglFormat(
                                item.riwayat_pekerjaan.tgl_mulai_bekerja
                              )
                            }}
                          </td>

                          <td style="border: 1px solid #000">
                            {{ formatNumber(item.honor_umk_jml) }}
                          </td>

                          <td style="border: 1px solid #000">
                            {{ formatNumber(item.kenaikan_masa_kerja) }}
                          </td>

                          <td style="border: 1px solid #000">
                            {{ formatNumber(item.tun_kesehatan) }}
                          </td>

                          <td style="border: 1px solid #000">
                            {{ formatNumber(item.jml_tdk_hadir) }}
                          </td>

                          <td style="border: 1px solid #000">
                            {{ formatNumber(item.pot_5_persen) }}
                          </td>

                          <td style="border: 1px solid #000">
                            {{ formatNumber(item.jml_bruto) }}
                          </td>

                          <td style="border: 1px solid #000">
                            {{ formatNumber(item.pot_kesehatan) }}
                          </td>

                          <td style="border: 1px solid #000">
                            {{ formatNumber(item.pot_bpjs_tk_dua_persen) }}
                          </td>

                          <td style="border: 1px solid #000">
                            {{ formatNumber(item.total_diterima) }}
                          </td>

                          <td
                            style="border: 1px solid #000"
                            class="bottom-text"
                            :ref="'refTdHonorTTD-' + cabangIndex + '-' + index"
                          >
                            {{ printRefTdHonorTTD(cabangIndex, index) }}
                          </td>
                          <td class="bottom-text">...............</td>
                        </tr>
                      </tbody>
                      <tr
                        class="top-text table-row-vfor"
                        v-if="gajisHonor.totalGajis"
                      >
                        <td
                          style="
                            border: 1px solid #000;
                            font-weight: bold;
                            text-align: center;
                          "
                          colspan="4"
                        >
                          JUMLAH
                        </td>
                        <td style="border: 1px solid #000"></td>
                        <td style="border: 1px solid #000"></td>

                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "unit_id"],
                                  val: null,
                                },
                              ],
                              "gajisHonor",
                              "honor_umk_jml"
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "unit_id"],
                                  val: null,
                                },
                              ],
                              "gajisHonor",
                              "kenaikan_masa_kerja"
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "unit_id"],
                                  val: null,
                                },
                              ],
                              "gajisHonor",
                              "tun_kesehatan"
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "unit_id"],
                                  val: null,
                                },
                              ],
                              "gajisHonor",
                              "jml_tdk_hadir"
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "unit_id"],
                                  val: null,
                                },
                              ],
                              "gajisHonor",
                              "pot_5_persen"
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "unit_id"],
                                  val: null,
                                },
                              ],
                              "gajisHonor",
                              "jml_bruto"
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "unit_id"],
                                  val: null,
                                },
                              ],
                              "gajisHonor",
                              "pot_kesehatan"
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "unit_id"],
                                  val: null,
                                },
                              ],
                              "gajisHonor",
                              "pot_bpjs_tk_dua_persen"
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "unit_id"],
                                  val: null,
                                },
                              ],
                              "gajisHonor",
                              "total_diterima"
                            )
                          }}
                        </td>

                        <td
                          style="border: 1px solid #000"
                          class="bottom-text"
                        ></td>
                        <td class="bottom-text"></td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <!-- /col-12  -->
          </div>
        </div>
        <!-- //shouldPrintGaji -->
      </div>
      <!-- end of v-for cabangs HONOR -->

      <div v-for="(unit, unitIndex) in units" :key="unit.id">
        <div
          v-if="
            shouldPrintGaji(
              [
                {
                  indexs: ['riwayat_pekerjaan', 'unit_id'],
                  val: unit.id,
                },
              ],
              'gajisHonor'
            ) !== 'skip'
          "
        >
          <div class="row add-page-break-before">
            <div class="col-12">
              <div class="p-3 mb-3">
                <div class="row">
                  <div class="col-12">
                    <h4 class="header-title">
                      <strong
                        >HONORARIUM TENAGA HONOR KANTOR
                        {{ toUpper(unit.cabang.nama) }} UNIT
                        {{ toUpper(unit.nama) }}
                      </strong>
                    </h4>
                    <h5 class="header-periode" style="padding-bottom: 20px">
                      <strong
                        >UNTUK BULAN: {{ printBulanNama() }}
                        {{ printTahun() }}</strong
                      >
                    </h5>

                    <table class="table table-sm table-custom no-margin-br">
                      <thead>
                        <tr class="center-top-text">
                          <th rowspan="3">NO</th>
                          <th rowspan="3" class="col-pegawai">NAMA</th>
                          <th rowspan="3">GOL.</th>
                          <th rowspan="3">JABATAN</th>
                          <th rowspan="3">MASA KERJA</th>
                          <th rowspan="3">TMT KONTRAK</th>
                          <th rowspan="2">HONOR (UMK)</th>
                          <th rowspan="2">
                            KENAIKAN MASA KERJA
                            <div class="small-text">(MK x 3% x UMK)</div>
                          </th>
                          <th rowspan="2">TUNJ. KESEHATAN</th>
                          <th rowspan="3">JML TIDAK MASUK</th>
                          <th rowspan="2">
                            POT.
                            <div class="small-text">(5%x6)9</div>
                          </th>
                          <th rowspan="2">JUMLAH BRUTO</th>
                          <th rowspan="1" colspan="2">POTONGAN</th>
                          <th rowspan="2">HONOR DITERIMA</th>
                          <th rowspan="3" colspan="2">TANDA TANGAN</th>
                        </tr>

                        <tr class="center-top-text">
                          <th>KESEHATAN</th>
                          <th>BPJS</th>
                        </tr>

                        <tr class="center-top-text">
                          <th style="border: none">(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                        </tr>
                        <tr class="center-top-text">
                          <th>1</th>
                          <th>2</th>
                          <th>3</th>
                          <th>4</th>
                          <th>5</th>
                          <th>6</th>
                          <th>7</th>
                          <th>8</th>
                          <th>9</th>
                          <th>10</th>
                          <th>11</th>
                          <th>12</th>
                          <th>13</th>
                          <th>14</th>
                          <th>15</th>
                          <th>16</th>
                          <th>17</th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr
                          v-for="(item, index) in filterGajisByConditions(
                            [
                              {
                                indexs: ['riwayat_pekerjaan', 'unit_id'],
                                val: unit.id,
                              },
                            ],
                            '',
                            'gajisHonor'
                          )"
                          :key="item.id"
                          :class="getPageBreakStyleHonorKontrak(index)"
                        >
                          <!-- :class="'top-text table-row-vfor'"
                            :style="getPageBreakStyle(index)" -->
                          <td
                            style="border: 1px solid #000"
                            :ref="
                              'refTdHonor-' + unitIndex + '-' + index + '-unit'
                            "
                          >
                            <!-- {{ callPrintIndexHonorKontrak(cabangIndex, index) }} -->
                            <!-- {{ printResults[(cabangIndex, index)] }} -->
                            <!-- {{ printIndexHonorKontrak(index) }} -->
                            <!-- <div v-if="printIndexComputed(index)"></div> -->
                            <!-- {{ printIndexComputed() }} -->
                            {{ printRefTdHonor(unitIndex, index, "-unit") }}
                          </td>
                          <td style="border: 1px solid #000">
                            <!-- {{ item.pegawai.nama }} -->
                            {{ item.pegawai.nama }}
                          </td>
                          <td style="border: 1px solid #000">
                            <!-- {{ item.golongan.nama }} PERBAIKI GAJI YAA KARENA JUNI TIDAK ADA GOLONGAN_ID-->
                          </td>

                          <td style="border: 1px solid #000">
                            <div v-if="shouldRenderSubBagian">
                              {{
                                printJabatanHonorKontrak(item.riwayat_pekerjaan)
                              }}
                            </div>
                          </td>

                          <td style="border: 1px solid #000">
                            {{ printMasaKerjaHonorKontrak(item) }}
                          </td>

                          <td style="border: 1px solid #000">
                            {{
                              convertTglFormat(
                                item.riwayat_pekerjaan.tgl_mulai_bekerja
                              )
                            }}
                          </td>

                          <td style="border: 1px solid #000">
                            {{ formatNumber(item.honor_umk_jml) }}
                          </td>

                          <td style="border: 1px solid #000">
                            {{ formatNumber(item.kenaikan_masa_kerja) }}
                          </td>

                          <td style="border: 1px solid #000">
                            {{ formatNumber(item.tun_kesehatan) }}
                          </td>

                          <td style="border: 1px solid #000">
                            {{ formatNumber(item.jml_tdk_hadir) }}
                          </td>

                          <td style="border: 1px solid #000">
                            {{ formatNumber(item.pot_5_persen) }}
                          </td>

                          <td style="border: 1px solid #000">
                            {{ formatNumber(item.jml_bruto) }}
                          </td>

                          <td style="border: 1px solid #000">
                            {{ formatNumber(item.pot_kesehatan) }}
                          </td>

                          <td style="border: 1px solid #000">
                            {{
                              formatNumber(
                                item.pot_bpjs_tk_satu_sembilanbelas_persen
                              )
                            }}
                          </td>

                          <td style="border: 1px solid #000">
                            {{ formatNumber(item.total_diterima) }}
                          </td>

                          <td
                            style="border: 1px solid #000"
                            class="bottom-text"
                            :ref="
                              'refTdHonorTTD-' +
                              unitIndex +
                              '-' +
                              index +
                              '-unit'
                            "
                          >
                            {{ printRefTdHonorTTD(unitIndex, index, "-unit") }}
                          </td>
                          <td class="bottom-text">...............</td>
                        </tr>
                      </tbody>
                      <tr
                        class="top-text table-row-vfor"
                        v-if="gajisHonor.totalGajis"
                      >
                        <td
                          style="
                            border: 1px solid #000;
                            font-weight: bold;
                            text-align: center;
                          "
                          colspan="4"
                        >
                          JUMLAH
                        </td>
                        <td style="border: 1px solid #000"></td>
                        <td style="border: 1px solid #000"></td>

                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "unit_id"],
                                  val: unit.id,
                                },
                              ],
                              "gajisHonor",
                              "honor_umk_jml"
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "unit_id"],
                                  val: unit.id,
                                },
                              ],
                              "gajisHonor",
                              "kenaikan_masa_kerja"
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "unit_id"],
                                  val: unit.id,
                                },
                              ],
                              "gajisHonor",
                              "tun_kesehatan"
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "unit_id"],
                                  val: unit.id,
                                },
                              ],
                              "gajisHonor",
                              "jml_tdk_hadir"
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "unit_id"],
                                  val: unit.id,
                                },
                              ],
                              "gajisHonor",
                              "pot_5_persen"
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "unit_id"],
                                  val: unit.id,
                                },
                              ],
                              "gajisHonor",
                              "jml_bruto"
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "unit_id"],
                                  val: unit.id,
                                },
                              ],
                              "gajisHonor",
                              "pot_kesehatan"
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "unit_id"],
                                  val: unit.id,
                                },
                              ],
                              "gajisHonor",
                              "pot_bpjs_tk_satu_sembilanbelas_persen"
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "unit_id"],
                                  val: unit.id,
                                },
                              ],
                              "gajisHonor",
                              "total_diterima"
                            )
                          }}
                        </td>

                        <td
                          style="border: 1px solid #000"
                          class="bottom-text"
                        ></td>
                        <td class="bottom-text"></td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <!-- /col-12  -->
          </div>
        </div>
        <!-- //shouldprintgaji -->
      </div>
      <!-- end of v-for units HONOR -->

      <div class="row add-page-break-before">
        <div class="col-12">
          <div class="p-3 mb-3">
            <div class="row">
              <div class="col-12">
                <h4 class="header-title">
                  <strong>TOTAL HONORARIUM TENAGA HONOR </strong>
                </h4>
                <h5 class="header-periode" style="padding-bottom: 20px">
                  <strong
                    >UNTUK BULAN: {{ printBulanNama() }}
                    {{ printTahun() }}</strong
                  >
                </h5>

                <table class="table table-sm table-custom no-margin-br">
                  <thead class="theadVisible">
                    <tr class="center-top-text">
                      <th rowspan="3">NO</th>
                      <th rowspan="3" class="col-pegawai">NAMA</th>
                      <th rowspan="3">GOL.</th>
                      <th rowspan="3">JABATAN</th>
                      <th rowspan="3">MASA KERJA</th>
                      <th rowspan="3">TMT KONTRAK</th>
                      <th rowspan="2">HONOR (UMK)</th>
                      <th rowspan="2">
                        KENAIKAN MASA KERJA
                        <div class="small-text">(MK x 3% x UMK)</div>
                      </th>
                      <th rowspan="2">TUNJ. KESEHATAN</th>
                      <th rowspan="3">JML TIDAK MASUK</th>
                      <th rowspan="2">
                        POT.
                        <div class="small-text">(5%x6)9</div>
                      </th>
                      <th rowspan="2">JUMLAH BRUTO</th>
                      <th rowspan="1" colspan="2">POTONGAN</th>
                      <th rowspan="2">HONOR DITERIMA</th>
                      <th rowspan="3" colspan="2">TANDA TANGAN</th>
                    </tr>

                    <tr class="center-top-text">
                      <th>KESEHATAN</th>
                      <th>BPJS</th>
                    </tr>

                    <tr class="center-top-text">
                      <th style="border: none">(Rp.)</th>
                      <th>(Rp.)</th>
                      <th>(Rp.)</th>
                      <th>(Rp.)</th>
                      <th>(Rp.)</th>
                      <th>(Rp.)</th>
                      <th>(Rp.)</th>
                      <th>(Rp.)</th>
                    </tr>
                    <tr class="center-top-text">
                      <th>1</th>
                      <th>2</th>
                      <th>3</th>
                      <th>4</th>
                      <th>5</th>
                      <th>6</th>
                      <th>7</th>
                      <th>8</th>
                      <th>9</th>
                      <th>10</th>
                      <th>11</th>
                      <th>12</th>
                      <th>13</th>
                      <th>14</th>
                      <th>15</th>
                      <th>16</th>
                      <th>17</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="gajisHonor" class="center-text">
                      <td
                        style="
                          border: 1px solid #000;
                          font-weight: bold;
                          text-align: center;
                        "
                        colspan="6"
                      >
                        TOTAL JUMLAH
                      </td>
                      <td style="border: 1px solid #000">
                        {{ formatNumber(gajisHonor.totalGajis.honor_umk_jml) }}
                      </td>
                      <td style="border: 1px solid #000">
                        {{
                          formatNumber(
                            gajisHonor.totalGajis.kenaikan_masa_kerja
                          )
                        }}
                      </td>
                      <td style="border: 1px solid #000">
                        {{ formatNumber(gajisHonor.totalGajis.tun_kesehatan) }}
                      </td>
                      <td style="border: 1px solid #000">
                        {{ formatNumber(gajisHonor.totalGajis.jml_tdk_hadir) }}
                      </td>
                      <td style="border: 1px solid #000">
                        {{ formatNumber(gajisHonor.totalGajis.pot_5_persen) }}
                      </td>
                      <td style="border: 1px solid #000">
                        {{ formatNumber(gajisHonor.totalGajis.jml_bruto) }}
                      </td>
                      <td style="border: 1px solid #000">
                        {{ formatNumber(gajisHonor.totalGajis.pot_kesehatan) }}
                      </td>
                      <td style="border: 1px solid #000">
                        {{
                          formatNumber(
                            gajisHonor.totalGajis.pot_bpjs_tk_dua_persen
                          )
                        }}
                      </td>
                      <td style="border: 1px solid #000">
                        {{ formatNumber(gajisHonor.totalGajis.total_diterima) }}
                      </td>
                      <td style="border: 1px solid #000"></td>
                      <td style="border: 1px solid #000"></td>
                    </tr>
                  </tbody>
                </table>
                <div class="row" v-if="gajisHonor">
                  <div class="col-12">
                    <p>
                      {{ cabangIndex }}
                      Terbilang : -----
                      {{
                        formatNumberTerbilang(gajisHonor.totalGajis.jml_bruto)
                      }}
                      Rupiah -----
                    </p>
                  </div>
                  <div class="row" style="text-align: center">
                    <div class="col-4">
                      Perumda Air Minum <br />
                      Tirta Hita Buleleng <br />
                      Menyetujui: <br />
                      <br />

                      <div
                        style="text-decoration: underline; padding-top: 35px"
                        v-if="pejabatMenyetujui"
                      >
                        {{ pejabatMenyetujui.nama }}
                      </div>

                      Direktur Umum
                    </div>
                    <div class="col-4">
                      <br />
                      <br />

                      Mengetahui:<br />
                      <br />

                      <div
                        style="text-decoration: underline; padding-top: 35px"
                        v-if="pejabatMengetahui"
                      >
                        {{ pejabatMengetahui.nama }}
                      </div>
                      Kepala Bagian Umum
                    </div>
                    <div class="col-4">
                      <br />
                      <div v-if="gajis">
                        Singaraja,
                        {{ convertTglIndonesia(gajis.gajis[0].created_at) }}
                      </div>

                      Dibuat Oleh:<br />
                      <br />

                      <div
                        style="text-decoration: underline; padding-top: 35px"
                        v-if="pejabatMembuat"
                      >
                        {{ pejabatMembuat.nama }}
                      </div>
                      Ka. Sub Bag. Personalia
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /col-12  -->
      </div>
    </div>
    <!-- /////////////////////////////////KONTRAK//////////////////////////////////////////// -->

    <div v-if="gajisKontrak">
      <div v-for="(cabang, cabangIndex) in cabangs" :key="cabang.id">
        <div
          v-if="
            shouldPrintGaji(
              [
                {
                  indexs: ['riwayat_pekerjaan', 'cabang_id'],
                  val: cabang.id,
                },
                {
                  indexs: ['riwayat_pekerjaan', 'unit_id'],
                  val: null,
                },
              ],
              'gajisKontrak'
            ) !== 'skip'
          "
        >
          <div class="row add-page-break-before">
            <div class="col-12">
              <div class="p-3 mb-3">
                <div class="row">
                  <div class="col-12">
                    <h4 class="header-title">
                      <strong
                        >HONORARIUM TENAGA KONTRAK KANTOR
                        {{ toUpper(cabang.nama) }}
                      </strong>
                    </h4>
                    <h5 class="header-periode" style="padding-bottom: 20px">
                      <strong
                        >UNTUK BULAN: {{ printBulanNama() }}
                        {{ printTahun() }}</strong
                      >
                    </h5>

                    <table class="table table-sm table-custom no-margin-br">
                      <thead>
                        <tr class="center-top-text">
                          <th rowspan="3">NO</th>
                          <th rowspan="3" class="col-pegawai">NAMA</th>
                          <th rowspan="3">GOL.</th>
                          <th rowspan="3">JABATAN</th>
                          <th rowspan="3">MASA KERJA</th>
                          <th rowspan="3">TMT KONTRAK</th>
                          <th rowspan="2">HONOR (UMK)</th>
                          <th rowspan="2">
                            KENAIKAN MASA KERJA
                            <div class="small-text">(MK x 3% x UMK)</div>
                          </th>
                          <th rowspan="2">TUNJ. KESEHATAN</th>
                          <th rowspan="3">JML TIDAK MASUK</th>
                          <th rowspan="2">
                            POT.
                            <div class="small-text">(5%x6)9</div>
                          </th>
                          <th rowspan="2">JUMLAH BRUTO</th>
                          <th rowspan="1" colspan="2">POTONGAN</th>
                          <th rowspan="2">HONOR DITERIMA</th>
                          <th rowspan="3" colspan="2">TANDA TANGAN</th>
                        </tr>

                        <tr class="center-top-text">
                          <th>KESEHATAN</th>
                          <th>BPJS</th>
                        </tr>

                        <tr class="center-top-text">
                          <th style="border: none">(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                        </tr>
                        <tr class="center-top-text">
                          <th>1</th>
                          <th>2</th>
                          <th>3</th>
                          <th>4</th>
                          <th>5</th>
                          <th>6</th>
                          <th>7</th>
                          <th>8</th>
                          <th>9</th>
                          <th>10</th>
                          <th>11</th>
                          <th>12</th>
                          <th>13</th>
                          <th>14</th>
                          <th>15</th>
                          <th>16</th>
                          <th>17</th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr
                          v-for="(item, index) in filterGajisByConditions(
                            [
                              {
                                indexs: ['riwayat_pekerjaan', 'cabang_id'],
                                val: cabang.id,
                              },
                              {
                                indexs: ['riwayat_pekerjaan', 'unit_id'],
                                val: null,
                              },
                            ],
                            '',
                            'gajisKontrak'
                          )"
                          :key="item.id"
                          :class="getPageBreakStyleHonorKontrak(index)"
                        >
                          <!-- :class="'top-text table-row-vfor'"
                            :style="getPageBreakStyle(index)" -->
                          <td
                            style="border: 1px solid #000"
                            :ref="'refTdKontrak-' + cabangIndex + '-' + index"
                          >
                            <!-- {{ callPrintIndexHonorKontrak(cabangIndex, index) }} -->
                            <!-- {{ printResults[(cabangIndex, index)] }} -->
                            <!-- {{ printIndexHonorKontrak(index) }} -->
                            <!-- <div v-if="printIndexComputed(index)"></div> -->
                            <!-- {{ printIndexComputed() }} -->
                            {{ printRefTdKontrak(cabangIndex, index) }}
                          </td>
                          <td style="border: 1px solid #000">
                            <!-- {{ item.pegawai.nama }} -->
                            {{ item.pegawai.nama }}
                          </td>
                          <td style="border: 1px solid #000">
                            <!-- {{ item.golongan.nama }} PERBAIKI GAJI YAA KARENA JUNI TIDAK ADA GOLONGAN_ID-->
                          </td>

                          <td style="border: 1px solid #000">
                            <div v-if="shouldRenderSubBagian">
                              {{
                                printJabatanHonorKontrak(item.riwayat_pekerjaan)
                              }}
                            </div>
                          </td>

                          <td style="border: 1px solid #000">
                            {{ printMasaKerjaHonorKontrak(item) }}
                          </td>

                          <td style="border: 1px solid #000">
                            {{
                              convertTglFormat(
                                item.riwayat_pekerjaan.tgl_mulai_bekerja
                              )
                            }}
                          </td>

                          <td style="border: 1px solid #000">
                            {{ formatNumber(item.honor_umk_jml) }}
                          </td>

                          <td style="border: 1px solid #000">
                            {{ formatNumber(item.kenaikan_masa_kerja) }}
                          </td>

                          <td style="border: 1px solid #000">
                            {{ formatNumber(item.tun_kesehatan) }}
                          </td>

                          <td style="border: 1px solid #000">
                            {{ formatNumber(item.jml_tdk_hadir) }}
                          </td>

                          <td style="border: 1px solid #000">
                            {{ formatNumber(item.pot_5_persen) }}
                          </td>

                          <td style="border: 1px solid #000">
                            {{ formatNumber(item.jml_bruto) }}
                          </td>

                          <td style="border: 1px solid #000">
                            {{ formatNumber(item.pot_kesehatan) }}
                          </td>

                          <td style="border: 1px solid #000">
                            {{
                              formatNumber(
                                item.pot_bpjs_tk_satu_sembilanbelas_persen
                              )
                            }}
                          </td>

                          <td style="border: 1px solid #000">
                            {{ formatNumber(item.total_diterima) }}
                          </td>

                          <td
                            style="border: 1px solid #000"
                            class="bottom-text"
                            :ref="
                              'refTdKontrakTTD-' + cabangIndex + '-' + index
                            "
                          >
                            {{ printRefTdKontrakTTD(cabangIndex, index) }}
                          </td>
                          <td class="bottom-text">...............</td>
                        </tr>
                      </tbody>
                      <tr
                        class="top-text table-row-vfor"
                        v-if="gajisKontrak.totalGajis"
                      >
                        <td
                          style="
                            border: 1px solid #000;
                            font-weight: bold;
                            text-align: center;
                          "
                          colspan="4"
                        >
                          JUMLAH
                        </td>
                        <td style="border: 1px solid #000"></td>
                        <td style="border: 1px solid #000"></td>

                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "unit_id"],
                                  val: null,
                                },
                              ],
                              "gajisKontrak",
                              "honor_umk_jml"
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "unit_id"],
                                  val: null,
                                },
                              ],
                              "gajisKontrak",
                              "kenaikan_masa_kerja"
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "unit_id"],
                                  val: null,
                                },
                              ],
                              "gajisKontrak",
                              "tun_kesehatan"
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "unit_id"],
                                  val: null,
                                },
                              ],
                              "gajisKontrak",
                              "jml_tdk_hadir"
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "unit_id"],
                                  val: null,
                                },
                              ],
                              "gajisKontrak",
                              "pot_5_persen"
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "unit_id"],
                                  val: null,
                                },
                              ],
                              "gajisKontrak",
                              "jml_bruto"
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "unit_id"],
                                  val: null,
                                },
                              ],
                              "gajisKontrak",
                              "pot_kesehatan"
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "unit_id"],
                                  val: null,
                                },
                              ],
                              "gajisKontrak",
                              "pot_bpjs_tk_satu_sembilanbelas_persen"
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "unit_id"],
                                  val: null,
                                },
                              ],
                              "gajisKontrak",
                              "total_diterima"
                            )
                          }}
                        </td>

                        <td
                          style="border: 1px solid #000"
                          class="bottom-text"
                        ></td>
                        <td class="bottom-text"></td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <!-- /col-12  -->
          </div>
        </div>
        <!-- //shouldprintgaji -->
      </div>
      <!-- //v-for cabangs kontrak -->

      <div v-for="(unit, unitIndex) in units" :key="unit.id">
        <div
          v-if="
            shouldPrintGaji(
              [
                {
                  indexs: ['riwayat_pekerjaan', 'unit_id'],
                  val: unit.id,
                },
              ],
              'gajisKontrak'
            ) !== 'skip'
          "
        >
          <div class="row add-page-break-before">
            <div class="col-12">
              <div class="p-3 mb-3">
                <div class="row">
                  <div class="col-12">
                    <h4 class="header-title">
                      <strong
                        >HONORARIUM TENAGA KONTRAK KANTOR
                        {{ toUpper(unit.cabang.nama) }} UNIT
                        {{ toUpper(unit.nama) }}
                      </strong>
                    </h4>
                    <h5 class="header-periode" style="padding-bottom: 20px">
                      <strong
                        >UNTUK BULAN: {{ printBulanNama() }}
                        {{ printTahun() }}</strong
                      >
                    </h5>

                    <table class="table table-sm table-custom no-margin-br">
                      <thead>
                        <tr class="center-top-text">
                          <th rowspan="3">NO</th>
                          <th rowspan="3" class="col-pegawai">NAMA</th>
                          <th rowspan="3">GOL.</th>
                          <th rowspan="3">JABATAN</th>
                          <th rowspan="3">MASA KERJA</th>
                          <th rowspan="3">TMT KONTRAK</th>
                          <th rowspan="2">HONOR (UMK)</th>
                          <th rowspan="2">
                            KENAIKAN MASA KERJA
                            <div class="small-text">(MK x 3% x UMK)</div>
                          </th>
                          <th rowspan="2">TUNJ. KESEHATAN</th>
                          <th rowspan="3">JML TIDAK MASUK</th>
                          <th rowspan="2">
                            POT.
                            <div class="small-text">(5%x6)9</div>
                          </th>
                          <th rowspan="2">JUMLAH BRUTO</th>
                          <th rowspan="1" colspan="2">POTONGAN</th>
                          <th rowspan="2">HONOR DITERIMA</th>
                          <th rowspan="3" colspan="2">TANDA TANGAN</th>
                        </tr>

                        <tr class="center-top-text">
                          <th>KESEHATAN</th>
                          <th>BPJS</th>
                        </tr>

                        <tr class="center-top-text">
                          <th style="border: none">(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                        </tr>
                        <tr class="center-top-text">
                          <th>1</th>
                          <th>2</th>
                          <th>3</th>
                          <th>4</th>
                          <th>5</th>
                          <th>6</th>
                          <th>7</th>
                          <th>8</th>
                          <th>9</th>
                          <th>10</th>
                          <th>11</th>
                          <th>12</th>
                          <th>13</th>
                          <th>14</th>
                          <th>15</th>
                          <th>16</th>
                          <th>17</th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr
                          v-for="(item, index) in filterGajisByConditions(
                            [
                              {
                                indexs: ['riwayat_pekerjaan', 'unit_id'],
                                val: unit.id,
                              },
                            ],
                            '',
                            'gajisKontrak'
                          )"
                          :key="item.id"
                          :class="getPageBreakStyleHonorKontrak(index)"
                        >
                          <!-- :class="'top-text table-row-vfor'"
                            :style="getPageBreakStyle(index)" -->
                          <td
                            style="border: 1px solid #000"
                            :ref="
                              'refTdKontrak-' +
                              unitIndex +
                              '-' +
                              index +
                              '-unit'
                            "
                          >
                            <!-- {{ callPrintIndexHonorKontrak(cabangIndex, index) }} -->
                            <!-- {{ printResults[(cabangIndex, index)] }} -->
                            <!-- {{ printIndexHonorKontrak(index) }} -->
                            <!-- <div v-if="printIndexComputed(index)"></div> -->
                            <!-- {{ printIndexComputed() }} -->
                            {{ printRefTdKontrak(unitIndex, index, "-unit") }}
                          </td>
                          <td style="border: 1px solid #000">
                            <!-- {{ item.pegawai.nama }} -->
                            {{ item.pegawai.nama }}
                          </td>
                          <td style="border: 1px solid #000">
                            <!-- {{ item.golongan.nama }} PERBAIKI GAJI YAA KARENA JUNI TIDAK ADA GOLONGAN_ID-->
                          </td>

                          <td style="border: 1px solid #000">
                            <div v-if="shouldRenderSubBagian">
                              {{
                                printJabatanHonorKontrak(item.riwayat_pekerjaan)
                              }}
                            </div>
                          </td>

                          <td style="border: 1px solid #000">
                            {{ printMasaKerjaHonorKontrak(item) }}
                          </td>

                          <td style="border: 1px solid #000">
                            {{
                              convertTglFormat(
                                item.riwayat_pekerjaan.tgl_mulai_bekerja
                              )
                            }}
                          </td>

                          <td style="border: 1px solid #000">
                            {{ formatNumber(item.honor_umk_jml) }}
                          </td>

                          <td style="border: 1px solid #000">
                            {{ formatNumber(item.kenaikan_masa_kerja) }}
                          </td>

                          <td style="border: 1px solid #000">
                            {{ formatNumber(item.tun_kesehatan) }}
                          </td>

                          <td style="border: 1px solid #000">
                            {{ formatNumber(item.jml_tdk_hadir) }}
                          </td>

                          <td style="border: 1px solid #000">
                            {{ formatNumber(item.pot_5_persen) }}
                          </td>

                          <td style="border: 1px solid #000">
                            {{ formatNumber(item.jml_bruto) }}
                          </td>

                          <td style="border: 1px solid #000">
                            {{ formatNumber(item.pot_kesehatan) }}
                          </td>

                          <td style="border: 1px solid #000">
                            {{
                              formatNumber(
                                item.pot_bpjs_tk_satu_sembilanbelas_persen
                              )
                            }}
                          </td>

                          <td style="border: 1px solid #000">
                            {{ formatNumber(item.total_diterima) }}
                          </td>

                          <td
                            style="border: 1px solid #000"
                            class="bottom-text"
                            :ref="
                              'refTdKontrakTTD-' +
                              unitIndex +
                              '-' +
                              index +
                              '-unit'
                            "
                          >
                            {{
                              printRefTdKontrakTTD(unitIndex, index, "-unit")
                            }}
                          </td>
                          <td class="bottom-text">...............</td>
                        </tr>
                      </tbody>
                      <tr
                        class="top-text table-row-vfor"
                        v-if="gajisKontrak.totalGajis"
                      >
                        <td
                          style="
                            border: 1px solid #000;
                            font-weight: bold;
                            text-align: center;
                          "
                          colspan="4"
                        >
                          JUMLAH
                        </td>
                        <td style="border: 1px solid #000"></td>
                        <td style="border: 1px solid #000"></td>

                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "unit_id"],
                                  val: unit.id,
                                },
                              ],
                              "gajisKontrak",
                              "honor_umk_jml"
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "unit_id"],
                                  val: unit.id,
                                },
                              ],
                              "gajisKontrak",
                              "kenaikan_masa_kerja"
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "unit_id"],
                                  val: unit.id,
                                },
                              ],
                              "gajisKontrak",
                              "tun_kesehatan"
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "unit_id"],
                                  val: unit.id,
                                },
                              ],
                              "gajisKontrak",
                              "jml_tdk_hadir"
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "unit_id"],
                                  val: unit.id,
                                },
                              ],
                              "gajisKontrak",
                              "pot_5_persen"
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "unit_id"],
                                  val: unit.id,
                                },
                              ],
                              "gajisKontrak",
                              "jml_bruto"
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "unit_id"],
                                  val: unit.id,
                                },
                              ],
                              "gajisKontrak",
                              "pot_kesehatan"
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "unit_id"],
                                  val: unit.id,
                                },
                              ],
                              "gajisKontrak",
                              "pot_bpjs_tk_satu_sembilanbelas_persen"
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "unit_id"],
                                  val: unit.id,
                                },
                              ],
                              "gajisKontrak",
                              "total_diterima"
                            )
                          }}
                        </td>

                        <td
                          style="border: 1px solid #000"
                          class="bottom-text"
                        ></td>
                        <td class="bottom-text"></td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <!-- /col-12  -->
          </div>
        </div>
        <!-- //shouldprintgaji -->
      </div>
      <div class="row add-page-break-before">
        <div class="col-12">
          <div class="p-3 mb-3">
            <div class="row">
              <div class="col-12">
                <h4 class="header-title">
                  <strong>TOTAL HONORARIUM TENAGA KONTRAK </strong>
                </h4>
                <h5 class="header-periode" style="padding-bottom: 20px">
                  <strong
                    >UNTUK BULAN: {{ printBulanNama() }}
                    {{ printTahun() }}</strong
                  >
                </h5>

                <table class="table table-sm table-custom no-margin-br">
                  <thead>
                    <tr class="center-top-text">
                      <th rowspan="3">NO</th>
                      <th rowspan="3" class="col-pegawai">NAMA</th>
                      <th rowspan="3">GOL.</th>
                      <th rowspan="3">JABATAN</th>
                      <th rowspan="3">MASA KERJA</th>
                      <th rowspan="3">TMT KONTRAK</th>
                      <th rowspan="2">HONOR (UMK)</th>
                      <th rowspan="2">
                        KENAIKAN MASA KERJA
                        <div class="small-text">(MK x 3% x UMK)</div>
                      </th>
                      <th rowspan="2">TUNJ. KESEHATAN</th>
                      <th rowspan="3">JML TIDAK MASUK</th>
                      <th rowspan="2">
                        POT.
                        <div class="small-text">(5%x6)9</div>
                      </th>
                      <th rowspan="2">JUMLAH BRUTO</th>
                      <th rowspan="1" colspan="2">POTONGAN</th>
                      <th rowspan="2">HONOR DITERIMA</th>
                      <th rowspan="3" colspan="2">TANDA TANGAN</th>
                    </tr>

                    <tr class="center-top-text">
                      <th>KESEHATAN</th>
                      <th>BPJS</th>
                    </tr>

                    <tr class="center-top-text">
                      <th style="border: none">(Rp.)</th>
                      <th>(Rp.)</th>
                      <th>(Rp.)</th>
                      <th>(Rp.)</th>
                      <th>(Rp.)</th>
                      <th>(Rp.)</th>
                      <th>(Rp.)</th>
                      <th>(Rp.)</th>
                    </tr>
                    <tr class="center-top-text">
                      <th>1</th>
                      <th>2</th>
                      <th>3</th>
                      <th>4</th>
                      <th>5</th>
                      <th>6</th>
                      <th>7</th>
                      <th>8</th>
                      <th>9</th>
                      <th>10</th>
                      <th>11</th>
                      <th>12</th>
                      <th>13</th>
                      <th>14</th>
                      <th>15</th>
                      <th>16</th>
                      <th>17</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr v-if="gajisKontrak" class="center-text">
                      <td
                        style="
                          border: 1px solid #000;
                          font-weight: bold;
                          text-align: center;
                        "
                        colspan="6"
                      >
                        TOTAL JUMLAH
                      </td>
                      <td style="border: 1px solid #000">
                        {{
                          formatNumber(gajisKontrak.totalGajis.honor_umk_jml)
                        }}
                      </td>
                      <td style="border: 1px solid #000">
                        {{
                          formatNumber(
                            gajisKontrak.totalGajis.kenaikan_masa_kerja
                          )
                        }}
                      </td>
                      <td style="border: 1px solid #000">
                        {{
                          formatNumber(gajisKontrak.totalGajis.tun_kesehatan)
                        }}
                      </td>
                      <td style="border: 1px solid #000">
                        {{
                          formatNumber(gajisKontrak.totalGajis.jml_tdk_hadir)
                        }}
                      </td>
                      <td style="border: 1px solid #000">
                        {{ formatNumber(gajisKontrak.totalGajis.pot_5_persen) }}
                      </td>
                      <td style="border: 1px solid #000">
                        {{ formatNumber(gajisKontrak.totalGajis.jml_bruto) }}
                      </td>
                      <td style="border: 1px solid #000">
                        {{
                          formatNumber(gajisKontrak.totalGajis.pot_kesehatan)
                        }}
                      </td>
                      <td style="border: 1px solid #000">
                        {{
                          formatNumber(
                            gajisKontrak.totalGajis.pot_bpjs_tk_dua_persen
                          )
                        }}
                      </td>
                      <td style="border: 1px solid #000">
                        {{
                          formatNumber(gajisKontrak.totalGajis.total_diterima)
                        }}
                      </td>
                      <td style="border: 1px solid #000"></td>
                      <td style="border: 1px solid #000"></td>
                    </tr>
                  </tbody>
                </table>
                <div class="row" v-if="gajisKontrak">
                  <div class="col-12">
                    <p>
                      {{ cabangIndex }}
                      Terbilang : -----
                      {{
                        formatNumberTerbilang(gajisKontrak.totalGajis.jml_bruto)
                      }}
                      Rupiah -----
                    </p>
                  </div>
                  <div class="row" style="text-align: center">
                    <div class="col-4">
                      Perumda Air Minum <br />
                      Tirta Hita Buleleng <br />
                      Menyetujui: <br />
                      <br />

                      <div
                        style="text-decoration: underline; padding-top: 35px"
                        v-if="pejabatMenyetujui"
                      >
                        {{ pejabatMenyetujui.nama }}
                      </div>

                      Direktur Umum
                    </div>
                    <div class="col-4">
                      <br />
                      <br />

                      Mengetahui:<br />
                      <br />

                      <div
                        style="text-decoration: underline; padding-top: 35px"
                        v-if="pejabatMengetahui"
                      >
                        {{ pejabatMengetahui.nama }}
                      </div>
                      Kepala Bagian Umum
                    </div>
                    <div class="col-4">
                      <br />
                      <div v-if="gajis">
                        Singaraja,
                        {{ convertTglIndonesia(gajis.gajis[0].created_at) }}
                      </div>

                      Dibuat Oleh:<br />
                      <br />

                      <div
                        style="text-decoration: underline; padding-top: 35px"
                        v-if="pejabatMembuat"
                      >
                        {{ pejabatMembuat.nama }}
                      </div>
                      Ka. Sub Bag. Personalia
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /col-12  -->
      </div>
    </div>
    <!-- end of v-if gajisKontrak KONTRAK -->
  </div>
  <!-- /section-to-print -->
</template>

<style scoped lang="scss">
// FIX!
.table-row-vfor {
  border: 1px solid #000;
  // border-left: 1px solid #000;
}

.center-top-text {
  vertical-align: top; /* Align text to the top */
  text-align: center; /* Center text horizontally */
}

.top-text {
  vertical-align: top;
}
.bottom-text {
  vertical-align: bottom;
}

.center-text {
  text-align: center;
}

.small-text {
  font-size: 8px;
}
.header-title {
  text-align: center;
}
.header-periode {
  text-align: center;
}

.add-page-break-before {
  page-break-before: always;
}
.add-page-break-after {
  page-break-after: always;
}

// /FIX!

.table {
  width: 100%;
  border: 1px solid #000; /* Adjust the border thickness as needed */
  border: collapse;
  // table-layout: fixed;
}

.table-custom td,
.table-custom th {
  padding: 0.25rem; /* Adjust this value as needed */
  vertical-align: middle; /* Center align the text vertically */
}

.table th,
.table td {
  border: 1px solid #000; /* Adjust the border thickness as needed */
  padding: 0;
}
.col-pegawai {
  width: 8%;
}

td {
  page-break-inside: avoid !important;
}

.no-border-terbilang {
  border-top: 1px solid #000 !important;
  border-style: hidden !important;
}

.theadVisible {
  // visibility: hidden;
}
.no-margin-br br {
  margin: 0;
  padding: 0;
  line-height: 0.8; /* Adjust as needed */
}

@media print {
  // table {
  //   page-break-inside: avoid;
  // } lama

  table {
    page-break-inside: auto;
  }

  tr {
    break-inside: avoid;
  }
  // tbody {
  //   display: block;
  // }
}
</style>
<script>
import axios from "axios";
import api from "@/api";
import { API_BASE_URL } from "@/global-constants";
import angkaTerbilang from "@develoka/angka-terbilang-js";
import _ from "lodash";
import { DateTime } from "luxon";
import { useCommonStore } from "@/stores/utility/common-store2";

export default {
  // Component logic goes here
  setup() {
    const commonStore = useCommonStore();

    return {
      commonStore,
    };
  },
  data() {
    return {
      tglGaji: this.$route.query.tgl,

      listGajisTetap: null,
      gajis: null,
      gajisHonor: null,
      gajisHonorLength: null,
      gajisKontrak: null,
      gajisDireksi: null,

      pejabatMengetahui: null,
      pejabatMembuat: null,
      pejabatMenyetujui: null,
      cabangs: null,
      units: null,
      cabangsLength: null,
      bagians: null,
      bidangs: null,
      subBagians: null,
      subBidangs: null,
      seksis: null,
      jabatans: null,
      totalRows: 0,
      previousSubBagianId: null,
      indexHonor: 0,
      indexKontrak: 0,
      gajiIndexLength: 0,
      printResults: [], // Array to store the results
    };
  },
  async mounted() {
    console.log("commonStore.cabangStore", this.commonStore.cabangStore);
    this.cabangs = _.sortBy(this.commonStore.cabangStore, ["id"]);

    this.bagians = _.sortBy(this.commonStore.bagianStore, ["id"]);
    this.bidangs = _.sortBy(this.commonStore.bidangStore, ["id"]);
    this.subBagians = _.sortBy(this.commonStore.subBagianStore, ["order"]);
    this.cabangsLength = this.cabangs.length;
    this.units = _.sortBy(this.commonStore.unitStore, ["id"]);
    this.subBidangs = _.sortBy(this.commonStore.subBidangStore, ["order"]);
    this.seksis = _.sortBy(this.commonStore.seksiStore, ["order"]);
    this.jabatans = _.sortBy(this.commonStore.jabatanStore, ["id"]);
    await this.fetchDataPejabatPembuatGaji();

    this.gajis = await this.fetchDataGaji([2, 3], this.tglGaji);
    this.gajisDireksi = await this.fetchDataGaji([1], this.tglGaji);
    this.gajisHonorLength = await this.fetchDataGaji(
      [4],
      this.tglGaji,
      "length"
    );
    console.log("GAJISHONOR", this.gajisHonorLength);

    this.gajisKontrak = await this.fetchDataGaji([5], this.tglGaji);
    this.indexHonor = 0;
  },
  computed: {
    shouldRenderSubBagian() {
      const condition1 = this.subBagians !== null;
      const condition2 = this.subBidangs !== null;
      const condition3 = this.seksis !== null;
      const condition4 = this.jabatans !== null;

      return condition1 && condition2 && condition3 && condition4; //salah satu tidak null
    },
    boldStyle() {
      // Define inline styles to make the text bold
      return {
        fontWeight: "bold",
      };
    },
  },

  methods: {
    printBulanNama() {
      const date = DateTime.fromFormat(this.tglGaji, "yyyy-M-dd");
      const monthNameIndonesian = date
        .setLocale("id")
        .toFormat("MMMM")
        .toUpperCase();
      return monthNameIndonesian;
    },
    printTahun() {
      return DateTime.fromFormat(this.tglGaji, "yyyy-M-dd").year;
    },
    // async setListGajiTetap() {
    //   this.listGajisTetap = [];
    //   this.cabangs.forEach((cabang) => {
    //     if (cabang.id == 1) {
    //       this.bagians.forEach((bagian) => {
    //         // console.log("SETLISTGAJITETAP LISTGAJI", this.gajis);
    //         this.listGajisTetap[cabang.id] = [];
    //         this.listGajisTetap[cabang.id] = 0;
    //       });
    //     }
    //   });

    //   console.log("SETLISTGAJITETAP", this.listGajisTetap);
    // },
    printRefTdHonor(cabangIndex, index) {
      console.log("printRefTd", cabangIndex + " " + index);
      const refName = "refTdHonor-" + cabangIndex + "-" + index;
      this.$nextTick(() => {
        const tdElement = this.$refs[refName];
        console.log("elemen1", this.$refs[refName]);

        if (tdElement) {
          // Do something with the tdElement
          var temp = this.indexHonor;
          this.indexHonor = temp + 1;
          tdElement[0].textContent = this.indexHonor;
          console.log("elemen", tdElement);
        }
      });
    },

    printRefTdHonorTTD(cabangIndex, index, tambahan = "") {
      const valueRef = "refTdHonor-" + cabangIndex + "-" + index + tambahan; //value
      const ttdRef = "refTdHonorTTD-" + cabangIndex + "-" + index + tambahan; //value
      this.$nextTick(() => {
        const tdElementTtd = this.$refs[ttdRef];
        console.log("printRefTdHonorTTD elementTTD", tdElementTtd);
        const tdElementValue = this.$refs[valueRef];
        console.log("printRefTdHonorTTD elementValue", tdElementValue);
        if (tdElementValue && tdElementTtd) {
          tdElementTtd[0].textContent = tdElementValue[0].textContent;
        }
      });
    },

    printRefTdKontrakTTD(cabangIndex, index, tambahan = "") {
      const valueRef = "refTdKontrak-" + cabangIndex + "-" + index + tambahan; //value
      const ttdRef = "refTdKontrakTTD-" + cabangIndex + "-" + index + tambahan; //value
      this.$nextTick(() => {
        const tdElementTtd = this.$refs[ttdRef];
        console.log("printRefTdKontrakTTD elementTTD", tdElementTtd);
        const tdElementValue = this.$refs[valueRef];
        console.log("printRefTdKontrakTTD elementValue", tdElementValue);
        if (tdElementValue && tdElementTtd) {
          tdElementTtd[0].textContent = tdElementValue[0].textContent;
        }
      });
    },

    printRefTdKontrak(cabangIndex, index, tambahan = "") {
      const refName = "refTdKontrak-" + cabangIndex + "-" + index + tambahan;
      console.log("printRefTdKontrak", refName);
      this.$nextTick(() => {
        const tdElement = this.$refs[refName];
        console.log("printRefTdKontrak", this.$refs[refName]);

        if (tdElement) {
          // Do something with the tdElement
          var temp = this.indexKontrak;
          this.indexKontrak = temp + 1;
          tdElement[0].textContent = this.indexKontrak;
          console.log("elemen", tdElement);
        }
      });
    },

    callPrintIndexHonorKontrak(cabangIndex, index) {
      // Use this.$nextTick() to ensure the method is called after rendering
      this.$nextTick(() => {
        const result = this.printIndexHonorKontrak(index);
        if (!this.printResults[cabangIndex]) {
          this.printResults[cabangIndex] = [];
        }
        this.printResults[cabangIndex].push(result);
        // this.printResults[index] = result;
        // this.$set(this.printResults, index, result);
        console.log("printResults", this.printResults);
        return result;
      });
      // return "hello";
    },

    printIndexHonorKontrak(index) {
      console.log("printIndexHonorKontrak", this.indexHonor + index);
      var temp1 = this.indexHonor;
      var temp2 = temp1 + 1;

      this.indexHonor = temp2;
      return temp2;
    },

    printMasaKerjaHonorKontrak(item) {
      //TODO nyari masa kerja bukan dari tgl sekarang, melainkan tgl pembuatan gaji
      const date1 = DateTime.fromISO(item.tgl_gaji);
      const date2 = DateTime.fromISO(item.riwayat_pekerjaan.tgl_mulai_bekerja);
      return Math.floor(date1.diff(date2, "years").years) + " tahun";
    },
    printNewLine(print) {
      if (print)
        return {
          display: "block",
          whiteSpace: "pre-line",
          height: "1em",
        };
      else
        return {
          display: "inline",
        };
    },
    printJabatanHonorKontrak(riwayatPekerjaan) {
      var namaTempat = null,
        title = "";
      if (riwayatPekerjaan.sub_bagian_id !== null) {
        namaTempat = _.find(this.subBagians, {
          id: riwayatPekerjaan.sub_bagian_id,
        });
        title = "Sub Bagian";
      }

      if (riwayatPekerjaan.sub_bidang_id !== null) {
        namaTempat = _.find(this.subBidangs, {
          id: riwayatPekerjaan.sub_bidang_id,
        });
        title = "Sub Bidang";
      }

      if (riwayatPekerjaan.seksi_id !== null) {
        namaTempat = _.find(this.seksis, {
          id: riwayatPekerjaan.seksi_id,
        });
        title = "Seksi";
      }

      if (namaTempat == null) {
        namaTempat = _.find(this.cabangs, {
          id: riwayatPekerjaan.cabang_id,
        });
        title = "Cabang";
      }

      console.log("namaTempat", namaTempat);
      var jabatan = _.find(this.jabatans, {
        id: riwayatPekerjaan.jabatan_id,
      });

      // return "haha";
      return jabatan.nama + " " + title + " " + namaTempat.nama;
    },
    printSubBagian(print, riwayatPekerjaan, dariCabang = null) {
      console.log(
        "printSubBagian RIWAYATPEKERJAAN",
        riwayatPekerjaan,
        dariCabang,
        print
      );

      var result = null;

      if (print) {
        console.log("printSubBagian masukprint");
        if (riwayatPekerjaan.sub_bagian_id !== null)
          result = _.find(this.subBagians, {
            id: riwayatPekerjaan.sub_bagian_id,
          });
        if (riwayatPekerjaan.sub_bidang_id !== null)
          result = _.find(this.subBidangs, {
            id: riwayatPekerjaan.sub_bidang_id,
          });
        if (riwayatPekerjaan.seksi_id !== null)
          result = _.find(this.seksis, {
            id: riwayatPekerjaan.seksi_id,
          });

        // const result = _.find(this.subBagians, { id: subBagianId });

        // console.log("PRINTSUBBAGIAN subBagianId", subBagianId);
        console.log("printSubBagian result", result);
        if (result) return result.nama;

        // return "PRINT SUBBAGIAN/SEKSI";
      }
    },

    convertTglFormat(tgl) {
      const parsedDate = DateTime.fromISO(tgl);

      // Format the date as "namaHari tanggal Bulan tahun" (Indonesian)
      const formattedDate = parsedDate.setLocale("id").toFormat("d MMMM yyyy");
      return formattedDate;
    },

    convertTglIndonesia(inputDate) {
      const parsedDate = DateTime.fromISO(inputDate);

      // Format the date in the desired Indonesian format
      const formattedDate = parsedDate.setLocale("id").toLocaleString({
        day: "numeric",
        month: "long",
        year: "numeric",
      });

      return formattedDate;
    },
    async fetchDataGaji(pegawaiStatusId, tglGaji, returnLength = null) {
      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "application/json",
        },
      };
      const data = {
        pegawai_status_ids: pegawaiStatusId,
        tgl_gaji: tglGaji,
      };
      console.log(data);
      try {
        const response = await axios.post(
          // "http://127.0.0.1/api/get_gaji_additional_parameter",
          `${API_BASE_URL}/get_gaji`,
          data,
          config
        );

        if (returnLength != null) {
          console.log("RETURN LENGTH", response.data.data.gajis.length);
          return response.data.data.gajis.length;
        }
        return response.data.data;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },

    async fetchDataPejabatPembuatGaji() {
      try {
        const response = await axios.get(`${API_BASE_URL}/pejabat_gaji`, {
          headers: {
            Authorization: api.defaults.headers.common["Authorization"],
            "Content-Type": "application/json",
          },
        });
        this.gaji = response.data.gajis;
        this.pejabatMengetahui = response.data.kabagUmum.simpeg_pegawai;
        this.pejabatMembuat = response.data.kasubagPersonalia.simpeg_pegawai;
        this.pejabatMenyetujui = response.data.dirum.simpeg_pegawai;
        // console.log("HASIL pejabatMengetahui", this.pejabatMengetahui);
        // console.log("HASIL SUMGAJIS", this.sumgajis);
        return response.data;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },

    formatNumberTerbilang(value) {
      if (typeof value === "string") {
        value = value.replace(/\./g, "");
      }

      if (value !== null && value !== undefined) {
        // Convert the value to a string and remove the decimal part (".00")
        const stringValue = value.toString().split(".")[0];
        // console.log(angkaTerbilang(stringValue));
        return _.startCase(angkaTerbilang(stringValue));
        // Add thousands separator
        // return stringValue.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
    },
    formatNumber(value) {
      // if (value) {
      //   return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      // }
      // return value;
      if (value !== null && value !== undefined) {
        // Convert the value to a string and remove the decimal part (".00")
        const stringValue = value.toString().split(".")[0];

        // Add thousands separator
        return stringValue.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
      return value;
    },
    async fetchDataCabang(length = null) {
      try {
        const response = await axios.get(`${API_BASE_URL}/cabang`, {
          headers: {
            Authorization: api.defaults.headers.common["Authorization"],
            "Content-Type": "application/json",
          },
        });
        // this.cabangs = response.data;
        if (length != null) {
          // console.log("fetchdatacabang", response.data.length);
          return response.data.length;
        }
        return response.data;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },

    async fetchDataUnit() {
      try {
        const response = await axios.get(`${API_BASE_URL}/unit`, {
          headers: {
            Authorization: api.defaults.headers.common["Authorization"],
            "Content-Type": "application/json",
          },
        });
        // this.cabangs = response.data;

        return response.data;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },

    async fetchDataBagian() {
      try {
        const response = await axios.get(`${API_BASE_URL}/bagian`, {
          headers: {
            Authorization: api.defaults.headers.common["Authorization"],
            "Content-Type": "application/json",
          },
        });
        // this.bagians = response.data;
        return response.data;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
    async fetchDataBidang() {
      try {
        const response = await axios.get(`${API_BASE_URL}/bidang`, {
          headers: {
            Authorization: api.defaults.headers.common["Authorization"],
            "Content-Type": "application/json",
          },
        });
        this.bidangs = response.data;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
    async fetchDataSubBagian() {
      try {
        const response = await axios.get(`${API_BASE_URL}/subBagian`, {
          headers: {
            Authorization: api.defaults.headers.common["Authorization"],
            "Content-Type": "application/json",
          },
        });
        this.subBagians = response.data;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
    async fetchDataSeksi() {
      try {
        const response = await axios.get(`${API_BASE_URL}/seksi`, {
          headers: {
            Authorization: api.defaults.headers.common["Authorization"],
            "Content-Type": "application/json",
          },
        });
        this.seksis = response.data;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
    async fetchDataJabatan() {
      try {
        const response = await axios.get(`${API_BASE_URL}/jabatan`, {
          headers: {
            Authorization: api.defaults.headers.common["Authorization"],
            "Content-Type": "application/json",
          },
        });
        this.jabatans = response.data;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
    async fetchDataSubBidang() {
      try {
        const response = await axios.get(`${API_BASE_URL}/subBidang`, {
          headers: {
            Authorization: api.defaults.headers.common["Authorization"],
            "Content-Type": "application/json",
          },
        });
        this.subBidangs = response.data;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
    toUpper(val) {
      return _.toUpper(val);
    },

    getSumsColJml(conditions, gajiTabel) {
      var filteredItems = this.getFilteredGajis(conditions, gajiTabel);
      // console.log("getSums", filteredItems);
      var sum = 0;
      filteredItems.forEach((item) => {
        var numericValue = parseFloat(item.tun_pph);
        var numericValue2 = parseFloat(item.jml_bruto);

        // Check if the numericValue is a valid number (not NaN)
        if (!isNaN(numericValue)) {
          sum += numericValue + numericValue2;
        }
      });
      return this.formatNumber(sum);
    },

    getSums(conditions, gajiTabel, col) {
      var filteredItems = this.getFilteredGajis(conditions, gajiTabel);
      // console.log("getSums", filteredItems);
      var sum = 0;
      filteredItems.forEach((item) => {
        var numericValue = parseFloat(item[col]);

        // Check if the numericValue is a valid number (not NaN)
        if (!isNaN(numericValue)) {
          sum += numericValue;
        }
      });
      // return sum;
      console.log("getSums", sum);
      return this.formatNumber(sum);
    },
    shouldPrintGaji(conditions, gajiTabel) {
      console.log("SHOULDPRINTGAJI");
      var filteredItems = this.getFilteredGajis(conditions, gajiTabel);
      console.log("SHOULDPRINTGAJI", filteredItems.length);
      if (filteredItems.length > 0) return true;
      else return "skip";
    },

    filterGajisByConditions(conditions, groupByCol, gajiTabel) {
      console.log("GROUPBYCOL ", groupByCol);
      // console.log("FILTERGAJIBYCONDITIONS", conditions);
      var filteredItems = this.getFilteredGajis(conditions, gajiTabel);
      // console.log("HASIL FILTER GAJI", filteredItems);
      this.totalRows = filteredItems.length;
      var hasil = filteredItems;

      const sortedData = _.orderBy(
        hasil,
        "riwayat_pekerjaan.jabatan_id",
        "asc"
      );

      if (groupByCol == "") {
        console.log("filterGajisByConditionsresult", sortedData);
        if (sortedData.length > 0) {
          console.log("filterGajisByConditions 0");
        }
        return sortedData;
        // else return "skip";
      }

      // Separate rows with sub_bagian: null, atau tidak dibawah subbagian, sub_bagian pasti 0
      const rowsWithNullSubBagian = _.filter(sortedData, (item) => {
        const condition1 = _.get(item, "riwayat_pekerjaan.jabatan_id") == 4; //cabang
        const condition2 = _.get(item, "riwayat_pekerjaan.jabatan_id") == 5; //bagian
        const condition3 = _.get(item, "riwayat_pekerjaan.jabatan_id") == 6; //bidang
        const condition4 = _.get(item, "riwayat_pekerjaan.jabatan_id") == 9; //unit

        return condition1 || condition2 || condition3 || condition4;
      }); //kabag/kacab/kaunit/kabid

      const dataWithoutNullSubBagian = _.reject(sortedData, (item) => {
        // Define your conditions using logical operators (&&, ||)
        const condition1 = _.get(item, "riwayat_pekerjaan.jabatan_id") == 4; //cabang
        const condition2 = _.get(item, "riwayat_pekerjaan.jabatan_id") == 5; //bagian
        const condition3 = _.get(item, "riwayat_pekerjaan.jabatan_id") == 6; //bidang
        const condition4 = _.get(item, "riwayat_pekerjaan.jabatan_id") == 9; //unit

        return condition1 || condition2 || condition3 || condition4;
      }); //staf/kasubid/kasubag/kaseksi

      const groupByKey = `riwayat_pekerjaan.${groupByCol}`;
      const groupBySubBagianId = _.groupBy(
        dataWithoutNullSubBagian,
        groupByKey
      ); //group by sub bagian id

      for (const subBagianId in groupBySubBagianId) {
        groupBySubBagianId[subBagianId] = _.orderBy(
          groupBySubBagianId[subBagianId],
          ["riwayat_pekerjaan.jabatan_id", "pegawai.nik"],
          ["asc", "asc"]
        );
        _.forEach(groupBySubBagianId[subBagianId], (value, index, array) => {
          if (index == 0) array[index].print_sub_bagian = true;
          else array[index].print_sub_bagian = false;
        });
      } //order by jabatanid, and then pegawai nik

      var flatGroupBySubBagianId = _.flatten(Object.values(groupBySubBagianId));

      var akhir = _.concat(rowsWithNullSubBagian, flatGroupBySubBagianId); //gabungkan sorted pegawai dengan kabag

      const flattenedData = _.flatten(Object.values(akhir));

      console.log("FILTER FINAL", flattenedData);
      return flattenedData;
    },
    getFilteredGajis(conditions, gajiTabel) {
      // return gajiTabel.gajis.filter((item) => {
      return this[gajiTabel].gajis.filter((item) => {
        // Check if all conditions are met
        return conditions.every((condition) => {
          // Initialize a variable to keep track of the current property value
          let currentPropertyValue = item;

          // Use a loop to traverse the nested properties if there are any
          for (const index of condition.indexs) {
            // Check if the current property exists in the object
            if (
              Object.prototype.hasOwnProperty.call(currentPropertyValue, index)
            ) {
              // if (currentPropertyValue.hasOwnProperty(index)) {
              // If the current item has the current property, update currentPropertyValue
              currentPropertyValue = currentPropertyValue[index];
            } else {
              // If the property is not found, return false (don't include in the result)
              return false;
            }
          }

          // Check if the final currentPropertyValue matches the provided value
          return currentPropertyValue === condition.val;
        });
      });
    },

    getPageBreakStyle(index) {
      var rowSaatIni = index + 1;

      // if (rowSaatIni === 10)
      //   return "top-text table-row-vfor add-page-break-after"; //page break di tr ke 10
      // if (rowSaatIni % 10 === 0)
      //   return "top-text table-row-vfor add-page-break-before";

      if (rowSaatIni > 12 && (rowSaatIni - 1) % 12 === 0) {
        return "top-text table-row-vfor add-page-break-before"; // Add page break before 11th, 21st, etc.
      }
      return "top-text table-row-vfor";
    },

    getPageBreakStyleHonorKontrak(index) {
      // var rowSaatIni = index + 1;
      // if (rowSaatIni === 20)
      //   return "top-text table-row-vfor add-page-break-after"; //page break di tr ke 7
      if (index % 20 === 0)
        return "top-text table-row-vfor add-page-break-before";
      return "top-text table-row-vfor";
    },
  },
};
</script>
